interface UxSVGProps {
  classes: any;
}

export const OtherServicesSVG = ({ classes }: UxSVGProps) => {
  return (
    <div className={`${classes}`}>
      <svg
        cache-id="6a19412eef8d48108c81e372242dcc35"
        id="eeV3ClaxE6U1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 432 337"
        shapeRendering="geometricPrecision"
        textRendering="geometricPrecision"
      >
        <defs>
          <linearGradient
            id="eeV3ClaxE6U4-fill"
            x1="226.269"
            y1="2.34231"
            x2="226.269"
            y2="338.833"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U4-fill-0"
              offset="0%"
              stopColor="rgb(111,204,221)"
            ></stop>
            <stop
              id="eeV3ClaxE6U4-fill-1"
              offset="100%"
              stopColor="rgb(57,83,164)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U7-fill"
            x1="64751.8"
            y1="76111.1"
            x2="63854.8"
            y2="81062.4"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U7-fill-0"
              offset="0%"
              stopColor="rgb(71,134,198)"
            ></stop>
            <stop
              id="eeV3ClaxE6U7-fill-1"
              offset="100%"
              stopColor="rgb(61,194,211)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U18-fill"
            x1="209.613"
            y1="22.3142"
            x2="209.326"
            y2="51.5316"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U18-fill-0"
              offset="0%"
              stopColor="rgb(71,134,198)"
            ></stop>
            <stop
              id="eeV3ClaxE6U18-fill-1"
              offset="100%"
              stopColor="rgb(61,194,211)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U23-fill"
            x1="26316"
            y1="67867.9"
            x2="26504.4"
            y2="61640"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U23-fill-0"
              offset="0%"
              stopColor="rgb(71,134,198)"
            ></stop>
            <stop
              id="eeV3ClaxE6U23-fill-1"
              offset="100%"
              stopColor="rgb(61,194,211)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U28-fill"
            x1="96.9678"
            y1="302.698"
            x2="116.499"
            y2="315.763"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U28-fill-0"
              offset="0%"
              stopColor="rgb(8,84,162)"
            ></stop>
            <stop
              id="eeV3ClaxE6U28-fill-1"
              offset="100%"
              stopColor="rgb(9,137,186)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U29-fill"
            x1="69345.8"
            y1="15070.3"
            x2="69533"
            y2="16104.1"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U29-fill-0"
              offset="0%"
              stopColor="rgb(8,84,162)"
            ></stop>
            <stop
              id="eeV3ClaxE6U29-fill-1"
              offset="100%"
              stopColor="rgb(9,137,186)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U30-fill"
            x1="100.428"
            y1="240.276"
            x2="60.6827"
            y2="267.5"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U30-fill-0"
              offset="0%"
              stopColor="rgb(253,210,72)"
            ></stop>
            <stop
              id="eeV3ClaxE6U30-fill-1"
              offset="100%"
              stopColor="rgb(248,188,34)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U31-fill"
            x1="99.3041"
            y1="240.392"
            x2="45.625"
            y2="280.391"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U31-fill-0"
              offset="0%"
              stopColor="rgb(253,210,72)"
            ></stop>
            <stop
              id="eeV3ClaxE6U31-fill-1"
              offset="100%"
              stopColor="rgb(242,162,49)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U33-fill"
            x1="49100.6"
            y1="158856"
            x2="42038.4"
            y2="164340"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U33-fill-0"
              offset="0%"
              stopColor="rgb(253,210,72)"
            ></stop>
            <stop
              id="eeV3ClaxE6U33-fill-1"
              offset="100%"
              stopColor="rgb(242,162,49)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U34-fill"
            x1="65.7139"
            y1="183.779"
            x2="80.1784"
            y2="224.164"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U34-fill-0"
              offset="0%"
              stopColor="rgb(24,38,57)"
            ></stop>
            <stop
              id="eeV3ClaxE6U34-fill-1"
              offset="100%"
              stopColor="rgb(1,1,1)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U38-fill"
            x1="14650"
            y1="35782.1"
            x2="18124.4"
            y2="35782.1"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U38-fill-0"
              offset="0%"
              stopColor="rgb(24,38,57)"
            ></stop>
            <stop
              id="eeV3ClaxE6U38-fill-1"
              offset="100%"
              stopColor="rgb(1,1,1)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U41-fill"
            x1="83.812"
            y1="252.05"
            x2="143.279"
            y2="267.469"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U41-fill-0"
              offset="0%"
              stopColor="rgb(36,94,164)"
            ></stop>
            <stop
              id="eeV3ClaxE6U41-fill-1"
              offset="100%"
              stopColor="rgb(32,61,116)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U44-fill"
            x1="25074.9"
            y1="117310"
            x2="31520.7"
            y2="119247"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U44-fill-0"
              offset="0%"
              stopColor="rgb(36,94,164)"
            ></stop>
            <stop
              id="eeV3ClaxE6U44-fill-1"
              offset="100%"
              stopColor="rgb(32,61,116)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U47-fill"
            x1="106.65"
            y1="196.78"
            x2="112.203"
            y2="194.148"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U47-fill-0"
              offset="0%"
              stopColor="rgb(111,76,48)"
            ></stop>
            <stop
              id="eeV3ClaxE6U47-fill-1"
              offset="100%"
              stopColor="rgb(93,53,38)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U48-fill"
            x1="3474.3"
            y1="8448.26"
            x2="3571.45"
            y2="8448.26"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U48-fill-0"
              offset="0%"
              stopColor="rgb(111,76,48)"
            ></stop>
            <stop
              id="eeV3ClaxE6U48-fill-1"
              offset="100%"
              stopColor="rgb(93,53,38)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U49-fill"
            x1="15011.4"
            y1="28686.7"
            x2="14935.4"
            y2="28228.3"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U49-fill-0"
              offset="0%"
              stopColor="rgb(71,134,198)"
            ></stop>
            <stop
              id="eeV3ClaxE6U49-fill-1"
              offset="100%"
              stopColor="rgb(61,194,211)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U50-fill"
            x1="14582.2"
            y1="28773.4"
            x2="14761.6"
            y2="28345.3"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U50-fill-0"
              offset="0%"
              stopColor="rgb(71,134,198)"
            ></stop>
            <stop
              id="eeV3ClaxE6U50-fill-1"
              offset="100%"
              stopColor="rgb(61,194,211)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U51-fill"
            x1="14352.3"
            y1="76298"
            x2="15218.5"
            y2="73034.6"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U51-fill-0"
              offset="0%"
              stopColor="rgb(71,134,198)"
            ></stop>
            <stop
              id="eeV3ClaxE6U51-fill-1"
              offset="100%"
              stopColor="rgb(61,194,211)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U52-fill"
            x1="13258"
            y1="42950.5"
            x2="13546.6"
            y2="42262.1"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U52-fill-0"
              offset="0%"
              stopColor="rgb(71,134,198)"
            ></stop>
            <stop
              id="eeV3ClaxE6U52-fill-1"
              offset="100%"
              stopColor="rgb(61,194,211)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U53-fill"
            x1="8144.14"
            y1="22555"
            x2="7861.51"
            y2="22876.7"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U53-fill-0"
              offset="0%"
              stopColor="rgb(111,76,48)"
            ></stop>
            <stop
              id="eeV3ClaxE6U53-fill-1"
              offset="100%"
              stopColor="rgb(93,53,38)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U54-fill"
            x1="5704.79"
            y1="14680"
            x2="5971.81"
            y2="14680"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U54-fill-0"
              offset="0%"
              stopColor="rgb(111,76,48)"
            ></stop>
            <stop
              id="eeV3ClaxE6U54-fill-1"
              offset="100%"
              stopColor="rgb(93,53,38)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U55-fill"
            x1="114.79"
            y1="200.088"
            x2="114.405"
            y2="194.842"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U55-fill-0"
              offset="0%"
              stopColor="rgb(101,105,176)"
            ></stop>
            <stop
              id="eeV3ClaxE6U55-fill-1"
              offset="100%"
              stopColor="rgb(85,172,224)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U56-fill"
            x1="4649.17"
            y1="13947.4"
            x2="4556.79"
            y2="14052"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U56-fill-0"
              offset="0%"
              stopColor="rgb(111,76,48)"
            ></stop>
            <stop
              id="eeV3ClaxE6U56-fill-1"
              offset="100%"
              stopColor="rgb(93,53,38)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U57-fill"
            x1="19310.9"
            y1="41920.7"
            x2="19543.9"
            y2="41042.1"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U57-fill-0"
              offset="0%"
              stopColor="rgb(71,134,198)"
            ></stop>
            <stop
              id="eeV3ClaxE6U57-fill-1"
              offset="100%"
              stopColor="rgb(61,194,211)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U58-fill"
            x1="3132.58"
            y1="13706.8"
            x2="3239.01"
            y2="13706.8"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U58-fill-0"
              offset="0%"
              stopColor="rgb(111,76,48)"
            ></stop>
            <stop
              id="eeV3ClaxE6U58-fill-1"
              offset="100%"
              stopColor="rgb(93,53,38)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U59-fill"
            x1="5528.3"
            y1="23264.1"
            x2="5864.21"
            y2="23264.1"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U59-fill-0"
              offset="0%"
              stopColor="rgb(111,76,48)"
            ></stop>
            <stop
              id="eeV3ClaxE6U59-fill-1"
              offset="100%"
              stopColor="rgb(93,53,38)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U60-fill"
            x1="3177.32"
            y1="19310.8"
            x2="3065.18"
            y2="19377.4"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U60-fill-0"
              offset="0%"
              stopColor="rgb(111,76,48)"
            ></stop>
            <stop
              id="eeV3ClaxE6U60-fill-1"
              offset="100%"
              stopColor="rgb(93,53,38)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U61-fill"
            x1="3603.54"
            y1="15272.9"
            x2="3738.93"
            y2="15272.9"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U61-fill-0"
              offset="0%"
              stopColor="rgb(111,76,48)"
            ></stop>
            <stop
              id="eeV3ClaxE6U61-fill-1"
              offset="100%"
              stopColor="rgb(93,53,38)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U73-fill"
            x1="4954.43"
            y1="15846.9"
            x2="5207.49"
            y2="15846.9"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U73-fill-0"
              offset="0%"
              stopColor="rgb(24,38,57)"
            ></stop>
            <stop
              id="eeV3ClaxE6U73-fill-1"
              offset="100%"
              stopColor="rgb(1,1,1)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U75-fill"
            x1="41737.2"
            y1="10015.5"
            x2="41911.3"
            y2="10977.5"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U75-fill-0"
              offset="0%"
              stopColor="rgb(8,84,162)"
            ></stop>
            <stop
              id="eeV3ClaxE6U75-fill-1"
              offset="100%"
              stopColor="rgb(9,137,186)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U77-fill"
            x1="91379.7"
            y1="10542.6"
            x2="91808.7"
            y2="12911.7"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U77-fill-0"
              offset="0%"
              stopColor="rgb(8,84,162)"
            ></stop>
            <stop
              id="eeV3ClaxE6U77-fill-1"
              offset="100%"
              stopColor="rgb(9,137,186)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U78-fill"
            x1="74185.9"
            y1="4438.38"
            x2="74420.7"
            y2="5735.36"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U78-fill-0"
              offset="0%"
              stopColor="rgb(8,84,162)"
            ></stop>
            <stop
              id="eeV3ClaxE6U78-fill-1"
              offset="100%"
              stopColor="rgb(9,137,186)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U79-fill"
            x1="77495.6"
            y1="165551"
            x2="80795.7"
            y2="146134"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U79-fill-0"
              offset="0%"
              stopColor="rgb(101,105,176)"
            ></stop>
            <stop
              id="eeV3ClaxE6U79-fill-1"
              offset="100%"
              stopColor="rgb(85,172,224)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U80-fill"
            x1="84078.8"
            y1="164568"
            x2="74114.5"
            y2="149937"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U80-fill-0"
              offset="0%"
              stopColor="rgb(101,105,176)"
            ></stop>
            <stop
              id="eeV3ClaxE6U80-fill-1"
              offset="100%"
              stopColor="rgb(85,172,224)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U82-fill"
            x1="68889.2"
            y1="165977"
            x2="58815.6"
            y2="151182"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U82-fill-0"
              offset="0%"
              stopColor="rgb(101,105,176)"
            ></stop>
            <stop
              id="eeV3ClaxE6U82-fill-1"
              offset="100%"
              stopColor="rgb(85,172,224)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U83-fill"
            x1="156.384"
            y1="218.198"
            x2="163.534"
            y2="214.144"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U83-fill-0"
              offset="0%"
              stopColor="rgb(62,72,150)"
            ></stop>
            <stop
              id="eeV3ClaxE6U83-fill-1"
              offset="100%"
              stopColor="rgb(45,52,134)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U84-fill"
            x1="163.965"
            y1="156.274"
            x2="146.738"
            y2="192.825"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U84-fill-0"
              offset="0%"
              stopColor="rgb(250,183,159)"
            ></stop>
            <stop
              id="eeV3ClaxE6U84-fill-1"
              offset="100%"
              stopColor="rgb(248,166,154)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U85-fill"
            x1="168.282"
            y1="168.56"
            x2="149.328"
            y2="188.597"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U85-fill-0"
              offset="0%"
              stopColor="rgb(245,138,122)"
            ></stop>
            <stop
              id="eeV3ClaxE6U85-fill-1"
              offset="100%"
              stopColor="rgb(248,166,154)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U86-fill"
            x1="8621.06"
            y1="33057"
            x2="8865.28"
            y2="32961.2"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U86-fill-0"
              offset="0%"
              stopColor="rgb(62,72,150)"
            ></stop>
            <stop
              id="eeV3ClaxE6U86-fill-1"
              offset="100%"
              stopColor="rgb(45,52,134)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U87-fill"
            x1="38095.6"
            y1="101978"
            x2="35310.2"
            y2="107727"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U87-fill-0"
              offset="0%"
              stopColor="rgb(250,183,159)"
            ></stop>
            <stop
              id="eeV3ClaxE6U87-fill-1"
              offset="100%"
              stopColor="rgb(248,166,154)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U88-fill"
            x1="37764.4"
            y1="95830.5"
            x2="35409.2"
            y2="98580.9"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U88-fill-0"
              offset="0%"
              stopColor="rgb(245,138,122)"
            ></stop>
            <stop
              id="eeV3ClaxE6U88-fill-1"
              offset="100%"
              stopColor="rgb(248,166,154)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U89-fill"
            x1="40789.5"
            y1="70737.9"
            x2="41522.1"
            y2="72085.5"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U89-fill-0"
              offset="0%"
              stopColor="rgb(62,72,150)"
            ></stop>
            <stop
              id="eeV3ClaxE6U89-fill-1"
              offset="100%"
              stopColor="rgb(45,52,134)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U93-fill"
            x1="204.724"
            y1="89.1611"
            x2="203.17"
            y2="105.4"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U93-fill-0"
              offset="0%"
              stopColor="rgb(90,46,105)"
            ></stop>
            <stop
              id="eeV3ClaxE6U93-fill-1"
              offset="100%"
              stopColor="rgb(36,9,61)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U95-fill"
            x1="190.497"
            y1="114.484"
            x2="174.335"
            y2="155.603"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U95-fill-0"
              offset="0%"
              stopColor="rgb(236,108,169)"
            ></stop>
            <stop
              id="eeV3ClaxE6U95-fill-1"
              offset="56%"
              stopColor="rgb(229,145,189)"
            ></stop>
            <stop
              id="eeV3ClaxE6U95-fill-2"
              offset="100%"
              stopColor="rgb(250,185,168)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U99-fill"
            x1="4161.14"
            y1="8822.37"
            x2="4176.61"
            y2="8838.69"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U99-fill-0"
              offset="0%"
              stopColor="rgb(245,138,122)"
            ></stop>
            <stop
              id="eeV3ClaxE6U99-fill-1"
              offset="100%"
              stopColor="rgb(248,166,154)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U100-fill"
            x1="10680.5"
            y1="20478.2"
            x2="10821.3"
            y2="20671.2"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U100-fill-0"
              offset="0%"
              stopColor="rgb(250,183,159)"
            ></stop>
            <stop
              id="eeV3ClaxE6U100-fill-1"
              offset="100%"
              stopColor="rgb(248,166,154)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U104-fill"
            x1="11912.5"
            y1="17515.6"
            x2="12087.1"
            y2="17270.6"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U104-fill-0"
              offset="0%"
              stopColor="rgb(245,138,122)"
            ></stop>
            <stop
              id="eeV3ClaxE6U104-fill-1"
              offset="100%"
              stopColor="rgb(248,166,154)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U105-fill"
            x1="24361.7"
            y1="58033.4"
            x2="23292"
            y2="63651.8"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U105-fill-0"
              offset="0%"
              stopColor="rgb(236,108,169)"
            ></stop>
            <stop
              id="eeV3ClaxE6U105-fill-1"
              offset="56%"
              stopColor="rgb(229,145,189)"
            ></stop>
            <stop
              id="eeV3ClaxE6U105-fill-2"
              offset="100%"
              stopColor="rgb(250,185,168)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U107-fill"
            x1="25112.3"
            y1="57244"
            x2="25450"
            y2="59441.1"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U107-fill-0"
              offset="0%"
              stopColor="rgb(71,134,198)"
            ></stop>
            <stop
              id="eeV3ClaxE6U107-fill-1"
              offset="100%"
              stopColor="rgb(61,194,211)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U112-fill"
            x1="15534.4"
            y1="13756"
            x2="15356.3"
            y2="13768.5"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U112-fill-0"
              offset="0%"
              stopColor="rgb(111,76,48)"
            ></stop>
            <stop
              id="eeV3ClaxE6U112-fill-1"
              offset="100%"
              stopColor="rgb(93,53,38)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U113-fill"
            x1="4569.31"
            y1="8843.02"
            x2="4650.4"
            y2="8842.8"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U113-fill-0"
              offset="0%"
              stopColor="rgb(111,76,48)"
            ></stop>
            <stop
              id="eeV3ClaxE6U113-fill-1"
              offset="100%"
              stopColor="rgb(93,53,38)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U114-fill"
            x1="3718.59"
            y1="4484.43"
            x2="3772.88"
            y2="4484.29"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U114-fill-0"
              offset="0%"
              stopColor="rgb(111,76,48)"
            ></stop>
            <stop
              id="eeV3ClaxE6U114-fill-1"
              offset="100%"
              stopColor="rgb(93,53,38)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U115-fill"
            x1="3338.93"
            y1="4001.08"
            x2="3381.32"
            y2="4001.08"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U115-fill-0"
              offset="0%"
              stopColor="rgb(111,76,48)"
            ></stop>
            <stop
              id="eeV3ClaxE6U115-fill-1"
              offset="100%"
              stopColor="rgb(93,53,38)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U116-fill"
            x1="3789.49"
            y1="4552.15"
            x2="3845.11"
            y2="4552.01"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U116-fill-0"
              offset="0%"
              stopColor="rgb(111,76,48)"
            ></stop>
            <stop
              id="eeV3ClaxE6U116-fill-1"
              offset="100%"
              stopColor="rgb(93,53,38)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U117-fill"
            x1="42113.2"
            y1="68450.1"
            x2="40625.4"
            y2="66124.4"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U117-fill-0"
              offset="0%"
              stopColor="rgb(101,105,176)"
            ></stop>
            <stop
              id="eeV3ClaxE6U117-fill-1"
              offset="100%"
              stopColor="rgb(85,172,224)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U118-fill"
            x1="36143"
            y1="58262.5"
            x2="32655.6"
            y2="58010.9"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U118-fill-0"
              offset="0%"
              stopColor="rgb(101,105,176)"
            ></stop>
            <stop
              id="eeV3ClaxE6U118-fill-1"
              offset="100%"
              stopColor="rgb(85,172,224)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U125-fill"
            x1="33612"
            y1="128803"
            x2="39051.5"
            y2="132484"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U125-fill-0"
              offset="0%"
              stopColor="rgb(36,94,164)"
            ></stop>
            <stop
              id="eeV3ClaxE6U125-fill-1"
              offset="100%"
              stopColor="rgb(32,61,116)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U126-fill"
            x1="25472.4"
            y1="127205"
            x2="30968.9"
            y2="130343"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U126-fill-0"
              offset="0%"
              stopColor="rgb(36,94,164)"
            ></stop>
            <stop
              id="eeV3ClaxE6U126-fill-1"
              offset="100%"
              stopColor="rgb(32,61,116)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U127-fill"
            x1="23484"
            y1="132330"
            x2="29905.6"
            y2="136672"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U127-fill-0"
              offset="0%"
              stopColor="rgb(36,94,164)"
            ></stop>
            <stop
              id="eeV3ClaxE6U127-fill-1"
              offset="100%"
              stopColor="rgb(32,61,116)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U128-fill"
            x1="11565.7"
            y1="16741.9"
            x2="11497.9"
            y2="16895.4"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U128-fill-0"
              offset="0%"
              stopColor="rgb(111,76,48)"
            ></stop>
            <stop
              id="eeV3ClaxE6U128-fill-1"
              offset="100%"
              stopColor="rgb(93,53,38)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U129-fill"
            x1="5275.54"
            y1="11467.9"
            x2="5259.96"
            y2="11473.8"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U129-fill-0"
              offset="0%"
              stopColor="rgb(111,76,48)"
            ></stop>
            <stop
              id="eeV3ClaxE6U129-fill-1"
              offset="100%"
              stopColor="rgb(93,53,38)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U131-fill"
            x1="48600.8"
            y1="85319.8"
            x2="47874"
            y2="78225"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U131-fill-0"
              offset="0%"
              stopColor="rgb(101,105,176)"
            ></stop>
            <stop
              id="eeV3ClaxE6U131-fill-1"
              offset="100%"
              stopColor="rgb(85,172,224)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U134-fill"
            x1="8644.96"
            y1="15499"
            x2="8865.29"
            y2="15499"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U134-fill-0"
              offset="0%"
              stopColor="rgb(111,76,48)"
            ></stop>
            <stop
              id="eeV3ClaxE6U134-fill-1"
              offset="100%"
              stopColor="rgb(93,53,38)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U135-fill"
            x1="18541.7"
            y1="20095.3"
            x2="18579.6"
            y2="20352.6"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U135-fill-0"
              offset="0%"
              stopColor="rgb(24,38,57)"
            ></stop>
            <stop
              id="eeV3ClaxE6U135-fill-1"
              offset="100%"
              stopColor="rgb(1,1,1)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U137-fill"
            x1="14237.8"
            y1="22444.1"
            x2="14480.9"
            y2="22351.7"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U137-fill-0"
              offset="0%"
              stopColor="rgb(111,76,48)"
            ></stop>
            <stop
              id="eeV3ClaxE6U137-fill-1"
              offset="100%"
              stopColor="rgb(93,53,38)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U138-fill"
            x1="13731.6"
            y1="10235.9"
            x2="14315.8"
            y2="10235.9"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U138-fill-0"
              offset="0%"
              stopColor="rgb(111,76,48)"
            ></stop>
            <stop
              id="eeV3ClaxE6U138-fill-1"
              offset="100%"
              stopColor="rgb(93,53,38)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U140-fill"
            x1="112734"
            y1="14717.6"
            x2="113112"
            y2="16807.2"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U140-fill-0"
              offset="0%"
              stopColor="rgb(8,84,162)"
            ></stop>
            <stop
              id="eeV3ClaxE6U140-fill-1"
              offset="100%"
              stopColor="rgb(9,137,186)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U141-fill"
            x1="131163"
            y1="15046.2"
            x2="131365"
            y2="16163.3"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U141-fill-0"
              offset="0%"
              stopColor="rgb(8,84,162)"
            ></stop>
            <stop
              id="eeV3ClaxE6U141-fill-1"
              offset="100%"
              stopColor="rgb(9,137,186)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U142-fill"
            x1="109744"
            y1="187801"
            x2="114012"
            y2="171714"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U142-fill-0"
              offset="0%"
              stopColor="rgb(71,134,198)"
            ></stop>
            <stop
              id="eeV3ClaxE6U142-fill-1"
              offset="100%"
              stopColor="rgb(61,194,211)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U143-fill"
            x1="112548"
            y1="186354"
            x2="108660"
            y2="171696"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U143-fill-0"
              offset="0%"
              stopColor="rgb(71,134,198)"
            ></stop>
            <stop
              id="eeV3ClaxE6U143-fill-1"
              offset="100%"
              stopColor="rgb(61,194,211)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U145-fill"
            x1="80587.7"
            y1="184217"
            x2="76619.1"
            y2="169258"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U145-fill-0"
              offset="0%"
              stopColor="rgb(71,134,198)"
            ></stop>
            <stop
              id="eeV3ClaxE6U145-fill-1"
              offset="100%"
              stopColor="rgb(61,194,211)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U146-fill"
            x1="18759.1"
            y1="19051.3"
            x2="18779.9"
            y2="19232.4"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U146-fill-0"
              offset="0%"
              stopColor="rgb(62,72,150)"
            ></stop>
            <stop
              id="eeV3ClaxE6U146-fill-1"
              offset="100%"
              stopColor="rgb(45,52,134)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U147-fill"
            x1="8062.55"
            y1="9943.99"
            x2="7944.25"
            y2="9959.3"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U147-fill-0"
              offset="0%"
              stopColor="rgb(62,72,150)"
            ></stop>
            <stop
              id="eeV3ClaxE6U147-fill-1"
              offset="100%"
              stopColor="rgb(45,52,134)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U148-fill"
            x1="67243.4"
            y1="111486"
            x2="70089.5"
            y2="114768"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U148-fill-0"
              offset="0%"
              stopColor="rgb(62,72,150)"
            ></stop>
            <stop
              id="eeV3ClaxE6U148-fill-1"
              offset="100%"
              stopColor="rgb(45,52,134)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U149-fill"
            x1="61098.9"
            y1="107729"
            x2="63470.5"
            y2="110465"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U149-fill-0"
              offset="0%"
              stopColor="rgb(62,72,150)"
            ></stop>
            <stop
              id="eeV3ClaxE6U149-fill-1"
              offset="100%"
              stopColor="rgb(45,52,134)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U150-fill"
            x1="18061.5"
            y1="30356"
            x2="18224.3"
            y2="30463.1"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U150-fill-0"
              offset="0%"
              stopColor="rgb(62,72,150)"
            ></stop>
            <stop
              id="eeV3ClaxE6U150-fill-1"
              offset="100%"
              stopColor="rgb(45,52,134)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U151-fill"
            x1="9039.29"
            y1="10887.5"
            x2="9001.57"
            y2="10959.4"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U151-fill-0"
              offset="0%"
              stopColor="rgb(62,72,150)"
            ></stop>
            <stop
              id="eeV3ClaxE6U151-fill-1"
              offset="100%"
              stopColor="rgb(45,52,134)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U152-fill"
            x1="55692.4"
            y1="100453"
            x2="58534.3"
            y2="103731"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U152-fill-0"
              offset="0%"
              stopColor="rgb(62,72,150)"
            ></stop>
            <stop
              id="eeV3ClaxE6U152-fill-1"
              offset="100%"
              stopColor="rgb(45,52,134)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U153-fill"
            x1="19488.8"
            y1="26553.4"
            x2="19825.9"
            y2="26942.1"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U153-fill-0"
              offset="0%"
              stopColor="rgb(62,72,150)"
            ></stop>
            <stop
              id="eeV3ClaxE6U153-fill-1"
              offset="100%"
              stopColor="rgb(45,52,134)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U155-fill"
            x1="7078.81"
            y1="15422.1"
            x2="7111.41"
            y2="15445.4"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U155-fill-0"
              offset="0%"
              stopColor="rgb(245,138,122)"
            ></stop>
            <stop
              id="eeV3ClaxE6U155-fill-1"
              offset="100%"
              stopColor="rgb(248,166,154)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U156-fill"
            x1="12660.4"
            y1="29346.7"
            x2="12574.5"
            y2="29865.1"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U156-fill-0"
              offset="0%"
              stopColor="rgb(250,183,159)"
            ></stop>
            <stop
              id="eeV3ClaxE6U156-fill-1"
              offset="100%"
              stopColor="rgb(248,166,154)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U158-fill"
            x1="336.987"
            y1="168.214"
            x2="338.692"
            y2="187.53"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U158-fill-0"
              offset="0%"
              stopColor="rgb(37,48,105)"
            ></stop>
            <stop
              id="eeV3ClaxE6U158-fill-1"
              offset="100%"
              stopColor="rgb(36,9,61)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U160-fill"
            x1="9174.56"
            y1="17596.7"
            x2="9168.93"
            y2="17680.3"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U160-fill-0"
              offset="0%"
              stopColor="rgb(250,183,159)"
            ></stop>
            <stop
              id="eeV3ClaxE6U160-fill-1"
              offset="100%"
              stopColor="rgb(248,166,154)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U161-fill"
            x1="6241.68"
            y1="9464.43"
            x2="6238.85"
            y2="9308.35"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U161-fill-0"
              offset="0%"
              stopColor="rgb(245,138,122)"
            ></stop>
            <stop
              id="eeV3ClaxE6U161-fill-1"
              offset="100%"
              stopColor="rgb(248,166,154)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U162-fill"
            x1="294.279"
            y1="229.989"
            x2="292.76"
            y2="199.778"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U162-fill-0"
              offset="0%"
              stopColor="rgb(9,93,169)"
            ></stop>
            <stop
              id="eeV3ClaxE6U162-fill-1"
              offset="100%"
              stopColor="rgb(14,111,184)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U163-fill"
            x1="295.989"
            y1="234.179"
            x2="294.758"
            y2="201.267"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U163-fill-0"
              offset="0%"
              stopColor="rgb(125,99,171)"
            ></stop>
            <stop
              id="eeV3ClaxE6U163-fill-1"
              offset="100%"
              stopColor="rgb(229,145,189)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U164-fill"
            x1="22926.1"
            y1="60919.3"
            x2="22480.2"
            y2="58968.2"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U164-fill-0"
              offset="0%"
              stopColor="rgb(9,93,169)"
            ></stop>
            <stop
              id="eeV3ClaxE6U164-fill-1"
              offset="100%"
              stopColor="rgb(14,111,184)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U165-fill"
            x1="27012.1"
            y1="62526.1"
            x2="26527.5"
            y2="58716.3"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U165-fill-0"
              offset="0%"
              stopColor="rgb(9,93,169)"
            ></stop>
            <stop
              id="eeV3ClaxE6U165-fill-1"
              offset="100%"
              stopColor="rgb(14,111,184)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U166-fill"
            x1="28784.2"
            y1="104187"
            x2="27898.1"
            y2="96415"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U166-fill-0"
              offset="0%"
              stopColor="rgb(9,93,169)"
            ></stop>
            <stop
              id="eeV3ClaxE6U166-fill-1"
              offset="100%"
              stopColor="rgb(14,111,184)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U167-fill"
            x1="28147.7"
            y1="77892.3"
            x2="27393.2"
            y2="71954.4"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U167-fill-0"
              offset="0%"
              stopColor="rgb(9,93,169)"
            ></stop>
            <stop
              id="eeV3ClaxE6U167-fill-1"
              offset="100%"
              stopColor="rgb(14,111,184)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U168-fill"
            x1="27923.4"
            y1="32491.4"
            x2="28550.5"
            y2="33614.7"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U168-fill-0"
              offset="0%"
              stopColor="rgb(62,72,150)"
            ></stop>
            <stop
              id="eeV3ClaxE6U168-fill-1"
              offset="100%"
              stopColor="rgb(45,52,134)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U169-fill"
            x1="19226.9"
            y1="14533.4"
            x2="21080.2"
            y2="14261.4"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U169-fill-0"
              offset="0%"
              stopColor="rgb(250,183,159)"
            ></stop>
            <stop
              id="eeV3ClaxE6U169-fill-1"
              offset="100%"
              stopColor="rgb(248,166,154)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U170-fill"
            x1="21081"
            y1="14532.2"
            x2="18623"
            y2="14006.9"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U170-fill-0"
              offset="0%"
              stopColor="rgb(245,138,122)"
            ></stop>
            <stop
              id="eeV3ClaxE6U170-fill-1"
              offset="100%"
              stopColor="rgb(248,166,154)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U171-fill"
            x1="41969.3"
            y1="73383.1"
            x2="41026.2"
            y2="69463.3"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U171-fill-0"
              offset="0%"
              stopColor="rgb(9,93,169)"
            ></stop>
            <stop
              id="eeV3ClaxE6U171-fill-1"
              offset="100%"
              stopColor="rgb(14,111,184)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U172-fill"
            x1="369.226"
            y1="184.918"
            x2="355.486"
            y2="203.142"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U172-fill-0"
              offset="0%"
              stopColor="rgb(156,209,151)"
            ></stop>
            <stop
              id="eeV3ClaxE6U172-fill-1"
              offset="100%"
              stopColor="rgb(28,173,200)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eeV3ClaxE6U184-fill"
            x1="15214.4"
            y1="48309.1"
            x2="14678.1"
            y2="45792.7"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eeV3ClaxE6U184-fill-0"
              offset="0%"
              stopColor="rgb(71,134,198)"
            ></stop>
            <stop
              id="eeV3ClaxE6U184-fill-1"
              offset="100%"
              stopColor="rgb(61,194,211)"
            ></stop>
          </linearGradient>
        </defs>
        <g id="eeV3ClaxE6U2" clipPath="url(#eeV3ClaxE6U185)">
          <g id="eeV3ClaxE6U3">
            <path
              id="eeV3ClaxE6U4"
              d="M28.376,50.9335C-2.45573,76.3685,-10.5123,112.18,15.9625,137.601C49.7167,170.025,129.812,223.67,120.516,245.833C110.057,270.762,114.298,298.632,140.693,317.717C167.088,336.802,218.416,343.786,254.391,329.162C294.448,312.879,300.825,279.205,293.702,251.478C286.578,223.75,308.287,172.362,335.57,161.258C357.777,152.221,384.5,147.215,403.762,135.983C471.773,96.3094,402.594,45.1069,347.606,23.3213C287.755,-0.388732,221.752,-5.40392,148.083,5.49551C101.978,12.311,57.0404,27.2989,28.376,50.9335Z"
              opacity="0.4"
              fill="url(#eeV3ClaxE6U4-fill)"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U5"
              d="M115.626,186.963L117.846,186.76L118.255,191.194L116.034,191.398L115.621,186.963L115.626,186.963ZM109.71,122.636L109.919,124.906L112.139,124.702L111.931,122.432L109.71,122.636ZM110.536,131.557L112.757,131.353L113.165,135.788L110.945,135.992L110.536,131.557ZM111.558,142.643L113.778,142.439L114.187,146.873L111.966,147.077L111.558,142.643ZM112.583,153.729L114.804,153.525L115.213,157.959L112.992,158.163L112.583,153.729ZM113.605,164.814L115.826,164.61L116.234,169.045L114.014,169.249L113.605,164.814ZM114.627,175.9L116.847,175.696L117.256,180.13L115.035,180.339L114.627,175.9Z"
              clip-rule="evenodd"
              fill="rgb(11,162,211)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <g
              id="eeV3ClaxE6U6"
              transform="matrix(0.577634 0 0 0.577634 121.490566 38.810206)"
            >
              <path
                id="eeV3ClaxE6U7"
                d="M368.576,95.6959C370.674,78.6816,358.56,63.1903,341.519,61.0952C324.478,59,308.962,71.0945,306.863,88.1088C304.765,105.123,316.878,120.614,333.92,122.71C350.961,124.805,366.477,112.71,368.576,95.6959Z"
                fill="url(#eeV3ClaxE6U7-fill)"
                stroke="none"
                strokeWidth="1"
              ></path>
              <path
                id="eeV3ClaxE6U8"
                d="M320.256,131.215C312.652,127.806,306.207,122.259,301.709,115.252L299.555,116.631C304.325,124.046,311.152,129.916,319.203,133.526L320.256,131.198L320.256,131.215ZM356.848,129.57C349.423,133.339,341.056,134.86,332.776,133.947L332.483,136.479C341.259,137.457,350.129,135.848,357.999,131.85L356.848,129.57ZM298.254,108.698C295.058,101.021,294.165,92.5821,295.682,84.4074L293.173,83.9284C292.655,86.671,292.398,89.4563,292.404,92.2471C292.4,98.2305,293.585,104.155,295.891,109.678L298.254,108.698ZM297.672,77.2549C300.61,69.4706,305.753,62.7082,312.475,57.7929L310.969,55.7354C303.846,60.9401,298.395,68.1034,295.282,76.3503L297.672,77.2371L297.672,77.2549ZM318.83,53.9439C324.702,51.0579,331.161,49.5604,337.706,49.5673C339.461,49.5693,341.214,49.6759,342.956,49.8865L343.28,47.359C341.431,47.1323,339.569,47.0182,337.706,47.0176C330.777,47.0136,323.939,48.599,317.72,51.6514L318.844,53.9439L318.83,53.9439ZM350.231,51.4297C358.194,53.8718,365.269,58.5814,370.59,64.9808L372.562,63.3579C366.924,56.5773,359.427,51.586,350.99,48.9953L350.231,51.4297ZM374.831,71.0779C378.526,77.5222,380.464,84.8215,380.45,92.2471C380.45,93.134,380.45,94.0209,380.37,94.8722L382.923,95.0319C382.981,94.1051,383.003,93.1783,383.008,92.2471C383.019,84.3804,380.968,76.6477,377.056,69.8186L374.836,71.0779L374.831,71.0779ZM379.273,102.211C377.323,110.297,373.052,117.638,366.983,123.336L368.724,125.203C375.162,119.17,379.692,111.389,381.755,102.818L379.273,102.211Z"
                clip-rule="evenodd"
                fill="rgb(255,255,255)"
                fillRule="evenodd"
                stroke="none"
                strokeWidth="1"
              ></path>
              <path
                id="eeV3ClaxE6U9"
                d="M339.771,127.575C338.103,127.676,336.43,127.66,334.765,127.526L334.548,130.116C336.337,130.258,338.134,130.275,339.926,130.164L339.771,127.575ZM330.541,126.927C328.903,126.598,327.29,126.153,325.714,125.597L324.825,128.036C326.511,128.655,328.242,129.14,330.004,129.486L330.541,126.95L330.541,126.927ZM323.386,124.644C321.853,123.968,320.369,123.186,318.945,122.302L317.568,124.52C319.09,125.467,320.677,126.307,322.316,127.034L323.373,124.661L323.386,124.644ZM316.88,120.906C315.525,119.929,314.244,118.855,313.047,117.691L311.231,119.549C312.521,120.794,313.897,121.948,315.348,123.003L316.88,120.906ZM311.306,115.886C310.194,114.64,309.166,113.321,308.228,111.94L306.065,113.376C307.064,114.864,308.167,116.279,309.365,117.611L311.306,115.886ZM306.909,109.811C306.083,108.36,305.355,106.855,304.733,105.306L302.317,106.255C302.978,107.921,303.757,109.538,304.648,111.093L306.909,109.811ZM303.893,102.951C303.392,101.354,303,99.7243,302.721,98.0736L300.158,98.517C300.456,100.282,300.874,102.024,301.411,103.732L303.893,102.96L303.893,102.951ZM302.401,95.6081C302.246,93.9441,302.206,92.2714,302.281,90.6018L299.683,90.4732C299.599,92.261,299.642,94.0525,299.812,95.8343L302.401,95.6081ZM302.481,88.1053C302.676,86.4463,302.988,84.8031,303.414,83.1877L300.9,82.527C300.443,84.2573,300.109,86.0176,299.901,87.795L302.481,88.1053ZM304.138,80.7977C304.678,79.2175,305.332,77.6778,306.092,76.1905L303.778,75.0065C302.962,76.6025,302.261,78.2548,301.682,79.9507L304.138,80.7977ZM307.309,74.0043C308.173,72.5734,309.136,71.2044,310.191,69.9071L308.175,68.2709C307.038,69.6589,305.999,71.1243,305.066,72.6564L307.287,73.9866L307.309,74.0043ZM311.839,68.027C312.983,66.8098,314.212,65.6747,315.516,64.6303L313.895,62.5994C312.496,63.7235,311.177,64.9428,309.947,66.2488L311.839,68.0225L311.839,68.027ZM317.519,63.1493C318.896,62.1998,320.337,61.3464,321.832,60.5951L320.677,58.2716C319.075,59.0772,317.531,59.9913,316.054,61.0075L317.519,63.1493ZM324.11,59.5575C325.654,58.918,327.24,58.3875,328.858,57.9701L328.228,55.4558C326.489,55.9015,324.783,56.469,323.124,57.1541L324.11,59.5575ZM331.31,57.4335C332.957,57.1433,334.622,56.9611,336.293,56.8881L336.195,54.294C334.408,54.3698,332.627,54.5654,330.866,54.8793L331.31,57.4335ZM338.802,56.8792C340.473,56.9127,342.138,57.0803,343.781,57.3803L344.225,54.8261C342.455,54.5152,340.665,54.3344,338.869,54.2852L338.789,56.8792L338.802,56.8792ZM346.237,57.8947C347.86,58.2977,349.452,58.8133,351.003,59.4378L351.984,57.0344C350.321,56.3603,348.611,55.806,346.868,55.376L346.237,57.8947ZM353.286,60.4577C354.787,61.1941,356.236,62.0342,357.62,62.9719L359.09,60.8301C357.609,59.8202,356.057,58.9192,354.445,58.1341L353.286,60.4577ZM359.641,64.4485C360.954,65.4847,362.193,66.6108,363.35,67.8186L365.233,66.0448C363.991,64.7551,362.663,63.5507,361.258,62.4398L359.641,64.4662L359.641,64.4485ZM365.015,69.6898C366.082,70.9739,367.057,72.3311,367.933,73.7516L370.154,72.4213C369.216,70.891,368.17,69.4299,367.023,68.0491L365.015,69.7031L365.015,69.6898ZM369.172,75.9333C369.941,77.4125,370.605,78.943,371.162,80.5139L373.618,79.6713C373.021,77.9782,372.306,76.329,371.477,74.736L369.172,75.9333ZM371.908,82.9084C372.35,84.5177,372.675,86.1567,372.881,87.8127L375.461,87.5023C375.24,85.7221,374.891,83.9602,374.417,82.2299L371.908,82.9084ZM373.107,90.3047C373.195,91.9733,373.17,93.6459,373.032,95.311L375.617,95.5372C375.773,93.7545,375.802,91.9629,375.701,90.1762L373.107,90.3047ZM372.73,97.7986C372.476,99.4499,372.1,101.08,371.606,102.676L374.084,103.448C374.615,101.734,375.02,99.9837,375.297,98.2111L372.73,97.8075L372.73,97.7986ZM370.784,105.035C370.175,106.588,369.461,108.097,368.648,109.554L370.913,110.835C371.788,109.264,372.554,107.634,373.205,105.958L370.784,105.022L370.784,105.035ZM367.342,111.687C366.426,113.087,365.411,114.421,364.305,115.678L366.25,117.403C367.435,116.057,368.525,114.632,369.514,113.137L367.342,111.705L367.342,111.687ZM362.581,117.478C361.386,118.648,360.113,119.735,358.771,120.733L360.316,122.821C361.753,121.752,363.117,120.587,364.398,119.336L362.581,117.478ZM356.705,122.147C355.295,123.044,353.823,123.839,352.3,124.528L353.365,126.892C354.999,126.152,356.58,125.3,358.096,124.342L356.705,122.147ZM349.981,125.477C348.413,126.054,346.805,126.519,345.171,126.87L345.709,129.411C347.464,129.034,349.19,128.533,350.874,127.912L349.981,125.477Z"
                clip-rule="evenodd"
                fill="rgb(255,255,255)"
                fillRule="evenodd"
                stroke="none"
                strokeWidth="1"
              ></path>
              <path
                id="eeV3ClaxE6U10"
                d="M351.878,88.4329L351.878,77.906C351.876,75.9505,351.097,74.0758,349.713,72.6927C348.328,71.3096,346.451,70.5309,344.492,70.5273L331.87,70.5273C329.912,70.5309,328.034,71.3096,326.65,72.6927C325.265,74.0758,324.486,75.9505,324.484,77.906L324.484,88.4329C323.023,90.8548,322.233,93.6205,322.194,96.4474C322.155,99.2742,322.868,102.061,324.261,104.522C325.655,106.983,327.677,109.031,330.123,110.456C332.569,111.881,335.35,112.631,338.181,112.631C341.013,112.631,343.794,111.881,346.239,110.456C348.685,109.031,350.708,106.983,352.101,104.522C353.494,102.061,354.208,99.2742,354.168,96.4474C354.129,93.6205,353.339,90.8548,351.878,88.4329ZM340.18,98.9155L340.18,104.822C340.179,105.351,339.968,105.858,339.593,106.232C339.219,106.606,338.711,106.816,338.181,106.817C337.652,106.816,337.144,106.606,336.769,106.232C336.395,105.858,336.184,105.351,336.183,104.822L336.183,98.9155C335.657,98.501,335.274,97.9333,335.086,97.2913C334.898,96.6493,334.916,95.9649,335.135,95.3331C335.355,94.7013,335.766,94.1535,336.312,93.7659C336.858,93.3783,337.511,93.17,338.181,93.17C338.851,93.17,339.504,93.3783,340.05,93.7659C340.596,94.1535,341.007,94.7013,341.227,95.3331C341.447,95.9649,341.464,96.6493,341.276,97.2913C341.089,97.9333,340.705,98.501,340.18,98.9155ZM345.509,82.4821C343.242,81.3193,340.73,80.7128,338.181,80.7128C335.632,80.7128,333.12,81.3193,330.853,82.4821L330.853,77.906C330.855,77.6346,330.964,77.3749,331.156,77.1826C331.348,76.9903,331.607,76.8807,331.879,76.8772L344.501,76.8772C344.773,76.8807,345.033,76.9903,345.224,77.1826C345.416,77.3749,345.525,77.6346,345.527,77.906L345.509,82.4821Z"
                clip-rule="evenodd"
                fill="rgb(255,255,255)"
                fillRule="evenodd"
                stroke="none"
                strokeWidth="1"
              ></path>
            </g>
            <path
              id="eeV3ClaxE6U11"
              d="M143.464,67.3211L144.592,69.2412L140.746,71.4938L139.618,69.5737L143.464,67.3211ZM181.926,44.7773L183.059,46.6974L179.213,48.9544L178.08,47.0344L181.926,44.7773ZM172.311,50.4133L173.443,52.3333L169.593,54.5904L168.465,52.6703L172.311,50.4133ZM162.695,56.0492L163.823,57.9693L159.977,60.2263L158.849,58.3063L162.695,56.0492ZM153.08,61.6852L154.208,63.6052L150.348,65.8756L149.22,63.9556L153.08,61.6852Z"
              clip-rule="evenodd"
              fill="rgb(11,162,211)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U12"
              d="M297.551,65.6281L298.24,63.5085L302.481,64.8876L301.788,67.0072L297.551,65.6281ZM234.12,44.9999L238.18,46.3302L238.868,44.215L234.813,42.8848L234.12,44.9999ZM244.54,48.3921L245.232,46.2726L249.474,47.6516L248.781,49.7712L244.54,48.3921ZM255.141,51.8375L255.834,49.7224L260.075,51.1015L259.382,53.2166L255.141,51.8375ZM265.742,55.2874L266.435,53.1678L270.677,54.5469L269.984,56.6664L265.742,55.2874ZM276.344,58.7328L277.037,56.6177L281.278,57.9923L280.585,60.1119L276.344,58.7328ZM286.95,62.1783L287.638,60.0631L291.88,61.4422L291.187,63.5573L286.95,62.1783Z"
              clip-rule="evenodd"
              fill="rgb(11,162,211)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <g
              id="eeV3ClaxE6U13"
              transform="matrix(1.412563 0 0 1.412563 -87.322736 -10.627458)"
            >
              <g id="eeV3ClaxE6U14" transform="matrix(1 0 0 1 0.000001 0)">
                <g id="eeV3ClaxE6U15" transform="matrix(1 0 0 1 0.000001 0)">
                  <path
                    id="eeV3ClaxE6U16"
                    d="M199.322,59.1763C194.903,57.1978,191.155,53.9796,188.534,49.9131L187.282,50.7113C190.054,55.0264,194.025,58.4423,198.71,60.542L199.322,59.2117L199.322,59.1763ZM220.61,58.2184C216.289,60.4081,211.423,61.2926,206.606,60.7637L206.437,62.2359C211.541,62.8036,216.699,61.8679,221.276,59.5443L220.61,58.214L220.61,58.2184ZM186.545,46.0774C185.278,43.0441,184.628,39.7901,184.631,36.5038C184.627,34.9747,184.767,33.4486,185.048,31.9454L183.591,31.666C182.649,36.7063,183.198,41.9116,185.172,46.645L186.545,46.0774ZM186.207,27.786C187.915,23.2572,190.908,19.3234,194.819,16.4653L193.931,15.2637C189.788,18.293,186.618,22.4608,184.808,27.2584L186.198,27.786L186.207,27.786ZM198.514,14.2261C202.864,12.0966,207.74,11.2769,212.549,11.867L212.74,10.3949C207.643,9.76531,202.472,10.6329,197.861,12.8914L198.514,14.2216L198.514,14.2261ZM216.781,12.7627C221.406,14.1886,225.514,16.9282,228.604,20.6469L229.75,19.7024C226.468,15.7524,222.103,12.8444,217.19,11.3349L216.746,12.7539L216.781,12.7627ZM231.069,24.1943C233.219,27.9428,234.346,32.1888,234.338,36.5083C234.338,37.0226,234.338,37.5281,234.294,38.0381L235.777,38.1312C235.808,37.5903,235.826,37.0537,235.826,36.5083C235.832,31.9323,234.638,27.4344,232.362,23.4626L231.069,24.1943ZM233.658,42.3083C232.525,47.0121,230.039,51.2828,226.508,54.5957L227.521,55.682C231.267,52.1734,233.903,47.6459,235.102,42.6586L233.658,42.3083Z"
                    clip-rule="evenodd"
                    fill="rgb(255,255,255)"
                    fillRule="evenodd"
                    stroke="none"
                    strokeWidth="1"
                  ></path>
                  <path
                    id="eeV3ClaxE6U17"
                    d="M210.657,56.7161C209.703,56.7737,208.745,56.7649,207.792,56.6895L207.668,58.1661C208.692,58.2496,209.72,58.26,210.746,58.1972L210.657,56.7161ZM205.376,56.3436C204.439,56.1531,203.518,55.8952,202.618,55.5721L202.09,56.9644C203.053,57.3216,204.044,57.6004,205.052,57.7981L205.358,56.3436L205.376,56.3436ZM201.286,55.04C200.412,54.6566,199.566,54.2121,198.754,53.7097L197.964,54.969C198.836,55.5096,199.744,55.9896,200.682,56.4057L201.286,55.0488L201.286,55.04ZM197.564,52.8982C196.787,52.3426,196.054,51.7289,195.37,51.0624L194.331,52.1222C195.068,52.8373,195.856,53.4983,196.689,54.0999L197.577,52.8982L197.564,52.8982ZM194.375,50.0292C193.732,49.3181,193.139,48.564,192.599,47.7722L191.359,48.5925C191.93,49.4432,192.561,50.2523,193.247,51.0136L194.357,50.0292L194.375,50.0292ZM191.861,46.5528C191.386,45.724,190.969,44.8631,190.613,43.9765L189.232,44.5219C189.611,45.4726,190.056,46.3957,190.564,47.2844L191.861,46.5528ZM190.134,42.6284C189.848,41.7162,189.624,40.7859,189.463,39.8437L187.997,40.0876C188.169,41.0971,188.408,42.0941,188.712,43.0718L190.134,42.6284ZM189.281,38.4292C189.192,37.477,189.17,36.5199,189.214,35.5647L187.726,35.4937C187.68,36.5156,187.706,37.5394,187.802,38.5578L189.281,38.4292ZM189.33,34.1368C189.439,33.1884,189.615,32.2489,189.858,31.3255L188.424,30.9486C188.159,31.9369,187.968,32.9432,187.851,33.9595L189.33,34.1368ZM190.276,29.9553C190.583,29.0517,190.956,28.1715,191.39,27.3214L190.058,26.6429C189.593,27.5569,189.192,28.5022,188.859,29.472L190.267,29.9553L190.276,29.9553ZM192.088,26.0709C192.583,25.2539,193.133,24.4716,193.735,23.7296L192.585,22.7939C191.934,23.5871,191.34,24.4259,190.809,25.3038L192.079,26.0709L192.088,26.0709ZM194.681,22.6521C195.335,21.956,196.037,21.307,196.782,20.7099L195.854,19.5481C195.056,20.1913,194.302,20.8876,193.598,21.6322L194.681,22.6521ZM197.933,19.854C198.719,19.3087,199.542,18.8197,200.397,18.3908L199.736,17.0605C198.813,17.521,197.922,18.044,197.071,18.6257L197.915,19.854L197.933,19.854ZM201.699,17.7965C202.583,17.4389,203.492,17.1426,204.417,16.9097L204.053,15.473C203.059,15.7304,202.084,16.0549,201.135,16.4441L201.699,17.8187L201.699,17.7965ZM205.816,16.5815C206.759,16.4163,207.711,16.3127,208.667,16.2712L208.61,14.7857C207.585,14.8293,206.564,14.9419,205.554,15.1227L205.816,16.5815ZM210.102,16.2667C211.058,16.2856,212.012,16.3806,212.953,16.5505L213.215,15.0916C212.203,14.913,211.178,14.8092,210.151,14.7812L210.102,16.2667ZM214.357,16.8476C215.285,17.0788,216.197,17.3752,217.084,17.7345L217.643,16.3598C216.692,15.9726,215.714,15.6554,214.716,15.4109L214.357,16.852L214.357,16.8476ZM218.389,18.3109C219.248,18.7322,220.077,19.2138,220.868,19.752L221.707,18.5237C220.857,17.9469,219.966,17.4312,219.042,16.9806L218.38,18.3109L218.389,18.3109ZM222.022,20.5946C222.773,21.1881,223.483,21.8326,224.145,22.5235L225.22,21.4992C224.511,20.7603,223.753,20.0699,222.951,19.4328L222.022,20.5946ZM225.1,23.5921C225.709,24.3267,226.266,25.1031,226.766,25.9157L228.036,25.1486C227.505,24.2732,226.911,23.4373,226.259,22.6476L225.114,23.5921L225.1,23.5921ZM227.476,27.1661C227.917,28.0117,228.297,28.8875,228.613,29.7868L230.021,29.3035C229.677,28.3354,229.267,27.3917,228.795,26.4789L227.463,27.1661L227.476,27.1661ZM229.04,31.157C229.293,32.0782,229.48,33.0162,229.599,33.9639L231.074,33.7865C230.947,32.7687,230.748,31.761,230.479,30.7712L229.04,31.157ZM229.728,35.3917C229.778,36.345,229.763,37.3005,229.684,38.2518L231.163,38.3849C231.25,37.3644,231.266,36.3391,231.211,35.3163L229.728,35.3917ZM229.51,39.6752C229.368,40.6186,229.152,41.5495,228.866,42.4599L230.288,42.9033C230.589,41.9232,230.821,40.923,230.981,39.9102L229.51,39.6752ZM228.396,43.8168C228.048,44.7046,227.641,45.5682,227.179,46.402L228.471,47.1337C228.979,46.2386,229.424,45.3096,229.804,44.3534L228.413,43.8168L228.396,43.8168ZM226.433,47.6259C225.907,48.4244,225.325,49.1845,224.692,49.9006L225.802,50.885C226.481,50.1165,227.106,49.3015,227.672,48.4462L226.433,47.6259ZM223.706,50.9383C223.023,51.6086,222.294,52.2309,221.525,52.8007L222.413,53.9935C223.236,53.3832,224.017,52.7181,224.749,52.0025L223.71,50.9383L223.706,50.9383ZM220.344,53.5989C219.537,54.1106,218.695,54.5654,217.825,54.9602L218.434,56.2904C219.368,55.8676,220.272,55.3801,221.139,54.8315L220.344,53.5767L220.344,53.5989ZM216.497,55.5011C215.6,55.8295,214.682,56.0962,213.748,56.2993L214.055,57.7493C215.058,57.5352,216.045,57.2492,217.008,56.8935L216.497,55.5011Z"
                    clip-rule="evenodd"
                    fill="rgb(255,255,255)"
                    fillRule="evenodd"
                    stroke="none"
                    strokeWidth="1"
                  ></path>
                  <path
                    id="eeV3ClaxE6U18"
                    d="M209.476,18.3633C213.07,18.3633,216.584,19.4276,219.573,21.4216C222.562,23.4156,224.891,26.2497,226.267,29.5655C227.642,32.8814,228.002,36.5299,227.3,40.0498C226.599,43.5697,224.867,46.8029,222.325,49.3404C219.783,51.8778,216.544,53.6056,213.019,54.3052C209.493,55.0048,205.839,54.6449,202.518,53.2709C199.197,51.8968,196.359,49.5705,194.362,46.5859C192.366,43.6014,191.301,40.0928,191.302,36.5039C191.303,31.6923,193.218,27.0782,196.626,23.6763C200.034,20.2744,204.656,18.3633,209.476,18.3633Z"
                    clip-rule="evenodd"
                    fill="url(#eeV3ClaxE6U18-fill)"
                    fillRule="evenodd"
                    stroke="none"
                    strokeWidth="1"
                  ></path>
                  <path
                    id="eeV3ClaxE6U19"
                    d="M209.475,24.4473C210.761,24.4464,212.019,24.8264,213.089,25.5392C214.158,26.252,214.993,27.2656,215.485,28.4517C215.978,29.6378,216.108,30.9432,215.857,32.2028C215.607,33.4624,214.988,34.6195,214.079,35.5279C213.17,36.4362,212.011,37.0549,210.75,37.3058C209.488,37.5566,208.181,37.4283,206.992,36.9371C205.804,36.4459,204.788,35.6138,204.073,34.5462C203.359,33.4785,202.977,32.2232,202.977,30.939C202.977,30.0865,203.146,29.2424,203.472,28.4548C203.799,27.6672,204.278,26.9515,204.882,26.3487C205.486,25.7458,206.202,25.2677,206.991,24.9415C207.78,24.6152,208.626,24.4473,209.479,24.4473L209.475,24.4473ZM214.525,37.688C215.907,37.9908,217.144,38.7551,218.033,39.8547C218.921,40.9544,219.407,42.3236,219.41,43.7363L219.41,43.8251C218.211,45.3056,216.696,46.4998,214.975,47.3201C213.254,48.1404,211.371,48.5661,209.464,48.5661C207.557,48.5661,205.674,48.1404,203.953,47.3201C202.232,46.4998,200.717,45.3056,199.518,43.8251L199.518,43.7363C199.523,42.3187,200.014,40.9456,200.909,39.8453C201.804,38.745,203.05,37.9837,204.439,37.688C205.831,38.9031,207.617,39.5727,209.466,39.5727C211.315,39.5727,213.102,38.9031,214.494,37.688L214.525,37.688Z"
                    clip-rule="evenodd"
                    fill="rgb(255,255,255)"
                    fillRule="evenodd"
                    stroke="none"
                    strokeWidth="1"
                  ></path>
                  <path
                    id="eeV3ClaxE6U20"
                    d="M196.836,28.0781C197.397,28.0781,197.946,28.2443,198.412,28.5557C198.879,28.867,199.243,29.3096,199.458,29.8273C199.672,30.3451,199.729,30.9148,199.619,31.4644C199.51,32.014,199.239,32.519,198.842,32.9152C198.445,33.3115,197.94,33.5813,197.389,33.6907C196.839,33.8,196.268,33.7439,195.75,33.5294C195.231,33.315,194.788,32.9518,194.476,32.4858C194.164,32.0198,193.998,31.472,193.998,30.9116C193.998,30.1601,194.297,29.4394,194.829,28.908C195.361,28.3767,196.083,28.0781,196.836,28.0781ZM199.056,33.8427C199.666,33.9722,200.212,34.3075,200.603,34.7922C200.993,35.2768,201.205,35.8811,201.201,36.5032L201.201,36.5431C200.678,37.1887,200.016,37.7093,199.265,38.0669C198.514,38.4245,197.692,38.6101,196.86,38.6101C196.028,38.6101,195.206,38.4245,194.455,38.0669C193.704,37.7093,193.042,37.1887,192.519,36.5431L192.519,36.5032C192.515,35.8811,192.727,35.2768,193.117,34.7922C193.508,34.3075,194.054,33.9722,194.664,33.8427C195.273,34.372,196.053,34.6636,196.86,34.6636C197.667,34.6636,198.447,34.372,199.056,33.8427Z"
                    clip-rule="evenodd"
                    fill="rgb(255,255,255)"
                    fillRule="evenodd"
                    stroke="none"
                    strokeWidth="1"
                  ></path>
                </g>
                <path
                  id="eeV3ClaxE6U21"
                  d="M222.111,28.0781C222.673,28.0781,223.221,28.2443,223.688,28.5557C224.155,28.867,224.518,29.3096,224.733,29.8273C224.948,30.3451,225.004,30.9148,224.895,31.4644C224.785,32.014,224.515,32.519,224.118,32.9152C223.721,33.3115,223.215,33.5813,222.665,33.6907C222.114,33.8,221.544,33.7439,221.025,33.5294C220.507,33.315,220.063,32.9518,219.752,32.4858C219.44,32.0198,219.273,31.472,219.273,30.9116C219.273,30.1601,219.572,29.4394,220.104,28.908C220.637,28.3767,221.359,28.0781,222.111,28.0781ZM224.305,33.8427C224.915,33.9722,225.461,34.3075,225.852,34.7922C226.242,35.2768,226.454,35.8811,226.45,36.5032L226.45,36.5431C225.927,37.1887,225.265,37.7093,224.514,38.0669C223.763,38.4245,222.941,38.6101,222.109,38.6101C221.277,38.6101,220.455,38.4245,219.704,38.0669C218.953,37.7093,218.291,37.1887,217.768,36.5431L217.768,36.5032C217.764,35.8805,217.977,35.2757,218.368,34.791C218.76,34.3062,219.307,33.9713,219.917,33.8427C220.525,34.3717,221.305,34.6631,222.111,34.6631C222.918,34.6631,223.697,34.3717,224.305,33.8427Z"
                  clip-rule="evenodd"
                  fill="rgb(255,255,255)"
                  fillRule="evenodd"
                  stroke="none"
                  strokeWidth="1"
                ></path>
              </g>
            </g>
            <g
              id="eeV3ClaxE6U22"
              transform="matrix(0.603367 0 0 0.603367 59.160838 39.135066)"
            >
              <path
                id="eeV3ClaxE6U23"
                d="M129.539,92.0949C132.674,78.0467,123.809,64.1212,109.739,60.9913C95.6679,57.8614,81.7202,66.7125,78.5853,80.7607C75.4505,94.8089,84.3157,108.735,98.3863,111.864C112.457,114.994,126.405,106.143,129.539,92.0949Z"
                fill="url(#eeV3ClaxE6U23-fill)"
                stroke="none"
                strokeWidth="1"
              ></path>
              <path
                id="eeV3ClaxE6U24"
                d="M107.174,72.7796L106.667,68.709L101.444,68.709L100.938,72.7796C99.4039,73.102,97.9304,73.6647,96.5723,74.4469L93.4367,72.0214L89.7415,75.7107L92.0021,78.624C91.02,80.0245,90.3131,81.5984,89.9192,83.2622L86.4238,83.7057L86.4238,88.9337L89.9192,89.3771C90.3121,91.0413,91.019,92.6154,92.0021,94.0153L89.7237,96.9154L93.4189,100.605L96.5545,98.1791C97.9126,98.9613,99.3861,99.5241,100.92,99.8464L101.427,103.913L106.65,103.913L107.156,99.8464C108.689,99.5248,110.161,98.9621,111.517,98.1791L114.657,100.605L118.353,96.9154L116.092,94.0021C117.072,92.6009,117.777,91.027,118.171,89.3638L121.666,88.9204L121.666,83.7057L118.171,83.2622C117.778,81.5987,117.073,80.0247,116.092,78.624L118.353,75.7107L114.657,72.0214L111.517,74.4469C110.161,73.664,108.689,73.1012,107.156,72.7796L107.174,72.7796ZM104.065,77.4533C105.822,77.4533,107.539,77.9735,109,78.948C110.461,79.9225,111.599,81.3075,112.271,82.928C112.944,84.5485,113.12,86.3317,112.777,88.0521C112.434,89.7724,111.588,91.3526,110.346,92.5929C109.104,93.8332,107.521,94.6778,105.798,95.02C104.075,95.3622,102.289,95.1866,100.666,94.5154C99.0425,93.8441,97.6552,92.7074,96.6791,91.249C95.7031,89.7906,95.1821,88.0759,95.1821,86.3219C95.1821,83.9713,96.1168,81.717,97.7807,80.054C99.4446,78.3911,101.702,77.4557,104.056,77.4533L104.065,77.4533Z"
                clip-rule="evenodd"
                fill="rgb(255,255,255)"
                fillRule="evenodd"
                stroke="none"
                strokeWidth="1"
              ></path>
              <path
                id="eeV3ClaxE6U25"
                d="M89.4311,119.349C83.0613,116.493,77.6606,111.849,73.8864,105.984L72.0833,107.137C76.0787,113.354,81.7991,118.276,88.5473,121.304L89.4356,119.357L89.4311,119.349ZM120.099,117.965C113.876,121.123,106.864,122.398,99.926,121.632L99.6817,123.756C107.035,124.575,114.468,123.226,121.062,119.876L120.099,117.965ZM70.9907,100.463C68.3123,94.0289,67.5639,86.9563,68.8366,80.1053L66.7359,79.7018C66.3019,82.0015,66.0863,84.3369,66.0919,86.6769C66.0883,91.6909,67.0816,96.6556,69.0143,101.283L70.9907,100.463ZM70.5066,74.1102C72.9687,67.5871,77.2788,61.9204,82.9112,57.801L81.6499,56.0761C75.6781,60.4431,71.1099,66.4524,68.5035,73.3697L70.5066,74.1279L70.5066,74.1102ZM88.2364,54.5994C93.1576,52.1801,98.571,50.9253,104.056,50.9323C105.528,50.9322,106.997,51.021,108.458,51.1984L108.729,49.0788C107.179,48.889,105.618,48.7942,104.056,48.795C98.2445,48.7865,92.5088,50.1157,87.2948,52.6794L88.2364,54.5994ZM114.551,52.4931C121.225,54.5368,127.156,58.4823,131.615,63.8449L133.267,62.488C128.541,56.8047,122.258,52.6209,115.186,50.4489L114.551,52.4931ZM135.168,68.9576C138.264,74.3573,139.889,80.4728,139.88,86.6946C139.88,87.4307,139.88,88.158,139.809,88.9118L141.95,89.0448C141.999,88.2688,142.017,87.4928,142.021,86.7124C142.029,80.1197,140.309,73.6397,137.033,67.9155L135.168,68.9709L135.168,68.9576ZM138.894,95.0488C137.262,101.824,133.684,107.977,128.599,112.75L130.056,114.316C135.453,109.26,139.249,102.738,140.977,95.5544L138.894,95.0488Z"
                clip-rule="evenodd"
                fill="rgb(255,255,255)"
                fillRule="evenodd"
                stroke="none"
                strokeWidth="1"
              ></path>
              <path
                id="eeV3ClaxE6U26"
                d="M105.793,116.294C104.395,116.378,102.992,116.365,101.596,116.254L101.414,118.423C102.912,118.542,104.417,118.556,105.917,118.467L105.793,116.294ZM98.056,115.753C96.6822,115.471,95.3302,115.091,94.01,114.618L93.2638,116.662C94.6755,117.182,96.1265,117.588,97.603,117.877L98.0471,115.753L98.056,115.753ZM92.0602,113.842C90.7785,113.274,89.5379,112.617,88.3473,111.878L87.1925,113.722C88.4739,114.517,89.8096,115.221,91.1897,115.829L92.078,113.842L92.0602,113.842ZM86.6151,110.707C85.4793,109.889,84.406,108.988,83.4041,108.011L81.8807,109.567C82.9606,110.613,84.1138,111.581,85.3316,112.463L86.6151,110.689L86.6151,110.707ZM81.9473,106.503C81.0142,105.458,80.1521,104.351,79.3669,103.191L77.5548,104.397C78.3907,105.643,79.3138,106.828,80.3173,107.944L81.9473,106.503ZM78.261,101.408C77.5665,100.192,76.9566,98.9299,76.4356,97.6303L74.4103,98.4285C74.9652,99.8238,75.6182,101.178,76.3645,102.481L78.261,101.408ZM75.7294,95.6437C75.3104,94.3079,74.9839,92.9448,74.7523,91.5642L72.6027,91.9234C72.8517,93.4015,73.2019,94.8608,73.6509,96.2911L75.7294,95.6437ZM74.4814,89.4934C74.352,88.0991,74.3179,86.6976,74.3793,85.2986L72.2074,85.1877C72.137,86.6871,72.1712,88.1894,72.3096,89.684L74.4814,89.4934ZM74.5525,83.2056C74.7115,81.8155,74.9712,80.4387,75.3297,79.0862L73.2245,78.5319C72.8388,79.9878,72.5598,81.4698,72.3895,82.9662L74.5525,83.2233L74.5525,83.2056ZM75.9382,77.0819C76.3907,75.7574,76.9369,74.4668,77.5726,73.2196L75.6362,72.2263C74.9466,73.5647,74.3529,74.9502,73.8596,76.3724L75.9204,77.0819L75.9382,77.0819ZM78.603,71.3883C79.3267,70.189,80.134,69.0421,81.0191,67.9561L79.3314,66.5815C78.3831,67.7474,77.5165,68.9771,76.7376,70.262L78.603,71.3883ZM82.4003,66.3775C83.3593,65.3573,84.3893,64.406,85.4826,63.5307L84.1236,61.8324C82.9505,62.7724,81.8448,63.7933,80.8148,64.8876L82.4003,66.3775ZM87.1614,62.2758C88.3154,61.4805,89.5234,60.7663,90.7767,60.1385L89.804,58.1874C88.4617,58.8633,87.1677,59.6307,85.9312,60.4844L87.1614,62.2581L87.1614,62.2758ZM92.682,59.2649C93.9815,58.7284,95.3172,58.2839,96.6792,57.9347L96.1463,55.8284C94.6905,56.2025,93.2628,56.6782,91.8737,57.2518L92.6953,59.2649L92.682,59.2649ZM98.7178,57.4912C100.098,57.2528,101.493,57.1047,102.893,57.0478L102.813,54.875C101.311,54.9374,99.8155,55.1004,98.3358,55.3628L98.7178,57.5045L98.7178,57.4912ZM104.993,57.0478C106.395,57.0843,107.791,57.2325,109.168,57.4912L109.555,55.3495C108.071,55.0933,106.57,54.9451,105.064,54.9061L104.993,57.0789L104.993,57.0478ZM111.211,57.8992C112.572,58.2374,113.907,58.6686,115.208,59.1896L116.03,57.1764C114.636,56.613,113.204,56.1492,111.744,55.7885L111.211,57.8992ZM117.123,60.0454C118.379,60.6641,119.591,61.3679,120.751,62.1517L121.986,60.3779C120.743,59.5324,119.442,58.7766,118.091,58.1165L117.123,60.0631L117.123,60.0454ZM122.452,63.3933C123.552,64.2629,124.591,65.2066,125.561,66.2179L127.138,64.7147C126.096,63.6335,124.984,62.6232,123.807,61.6905L122.452,63.3933ZM126.956,67.7832C127.851,68.8585,128.667,69.9966,129.399,71.1887L131.259,70.0624C130.476,68.7784,129.599,67.5542,128.635,66.3997L126.956,67.7832ZM130.438,73.0156C131.082,74.2557,131.64,75.5388,132.108,76.8557L134.164,76.1507C133.67,74.7316,133.077,73.3491,132.388,72.0135L130.456,73.0156L130.438,73.0156ZM132.734,78.86C133.1,80.2098,133.371,81.5833,133.547,82.9706L135.71,82.7089C135.521,81.2114,135.224,79.7294,134.821,78.2747L132.721,78.8423L132.734,78.86ZM133.738,85.068C133.809,86.4662,133.787,87.8676,133.671,89.2628L135.843,89.4579C135.974,87.9568,135.998,86.4483,135.914,84.9438L133.742,85.0502L133.738,85.068ZM133.418,91.3469C133.206,92.7297,132.892,94.0949,132.476,95.4309L134.555,96.0738C135,94.6386,135.34,93.1729,135.572,91.6883L133.418,91.3469ZM131.788,97.413C131.281,98.7133,130.687,99.9785,130.011,101.2L131.903,102.273C132.639,100.961,133.282,99.5994,133.827,98.1979L131.797,97.413L131.788,97.413ZM128.906,102.996C128.136,104.164,127.286,105.277,126.361,106.326L127.986,107.771C128.982,106.646,129.896,105.452,130.722,104.197L128.906,102.996ZM124.908,107.847C123.906,108.827,122.839,109.739,121.715,110.578L123.007,112.325C124.212,111.43,125.354,110.456,126.427,109.408L124.908,107.847ZM119.983,111.762C118.799,112.511,117.564,113.178,116.288,113.758L117.176,115.74C118.545,115.119,119.869,114.404,121.138,113.598L119.974,111.762L119.983,111.762ZM114.347,114.551C113.031,115.033,111.684,115.423,110.314,115.718L110.758,117.846C112.229,117.532,113.676,117.114,115.089,116.596L114.347,114.551Z"
                clip-rule="evenodd"
                fill="rgb(255,255,255)"
                fillRule="evenodd"
                stroke="none"
                strokeWidth="1"
              ></path>
            </g>
            <g
              id="eeV3ClaxE6U27"
              style={{ mixBlendMode: "multiply" }}
              opacity="0.35"
            >
              <path
                id="eeV3ClaxE6U28"
                style={{ mixBlendMode: "multiply" }}
                d="M110.647,322.43C159.092,322.43,198.363,317.682,198.363,311.824C198.363,305.966,159.092,301.217,110.647,301.217C62.2026,301.217,22.9307,305.966,22.9307,311.824C22.9307,317.682,62.2026,322.43,110.647,322.43Z"
                opacity="0.35"
                fill="url(#eeV3ClaxE6U28-fill)"
                stroke="none"
                strokeWidth="1"
              ></path>
              <path
                id="eeV3ClaxE6U29"
                style={{ mixBlendMode: "multiply" }}
                d="M110.652,316.048C149.736,316.048,181.438,314.155,181.438,311.818C181.438,309.481,149.744,307.588,110.652,307.588C71.5591,307.588,39.8613,309.486,39.8613,311.818C39.8613,314.151,71.5547,316.048,110.652,316.048Z"
                opacity="0.35"
                clip-rule="evenodd"
                fill="url(#eeV3ClaxE6U29-fill)"
                fillRule="evenodd"
                stroke="none"
                strokeWidth="1"
              ></path>
            </g>
            <path
              id="eeV3ClaxE6U30"
              d="M131.242,243.097C125.517,237.141,117.349,234.334,103.941,224.473C99.0711,220.943,94.7979,216.659,91.2831,211.782C82.8445,200.004,74.0196,196.071,65.4256,197.41C57.0448,198.741,48.8949,205.042,41.5978,213.999C14.3147,247.491,18.7382,286.663,50.8935,302.369C71.2082,312.293,118.402,306.272,132.197,285.71C137.895,277.205,142.94,255.264,131.242,243.097Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U30-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U31"
              d="M61.384,198.426C54.4333,200.825,47.718,206.487,41.5978,213.994C14.3147,247.487,18.7382,286.659,50.8935,302.365C65.2968,309.402,93.215,308.418,113.157,299.926L113.374,299.833C121.462,296.357,128.222,291.638,132.197,285.705C134.075,282.903,135.883,278.611,137.047,273.733C127.76,283.564,96.6304,295.119,60.589,267.924C52.4746,261.8,47.3582,252.067,49.2591,242.542C50.556,236.051,54.3889,230.88,55.8545,214.425C56.2009,210.487,55.8501,203.654,61.384,198.426Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U31-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U32"
              d="M37.1382,266.904C38.5506,266.797,39.732,266.744,40.9134,266.58C38.9454,259.247,38.1141,251.656,38.4484,244.072C38.5906,241.018,38.9438,237.978,39.5055,234.973C37.2404,234.64,34.7355,234.383,31.8975,234.179C34.5021,233.821,37.1297,233.656,39.7586,233.687C42.3391,221.271,48.4415,210.287,57.3863,202.141C58.9662,200.701,60.627,199.353,62.3606,198.102L63.1867,197.871C61.4901,199.091,59.3272,201.188,57.7905,202.589C48.97,210.624,42.9431,221.444,40.3715,233.704C49.6983,233.997,57.937,237.354,64.7234,246.209C55.3966,239.673,50.0359,236.604,40.1006,235.061C39.5444,238.046,39.1942,241.066,39.0525,244.098C38.7188,251.642,39.5487,259.191,41.513,266.483C42.5304,266.303,43.5273,266.022,44.4887,265.644L44.7063,266.208C43.7258,266.593,42.7098,266.881,41.6728,267.068C41.7706,267.423,41.8683,267.777,41.9704,268.132C43.0185,267.952,44.0454,267.665,45.0349,267.276L45.2526,267.839C44.2482,268.237,43.2068,268.534,42.1436,268.726C42.2724,269.17,42.4057,269.613,42.5433,270.025C43.5821,269.845,44.5999,269.559,45.5812,269.174L45.7989,269.737C44.8056,270.132,43.7763,270.429,42.7254,270.624C45.7321,279.761,50.1546,288.37,55.8318,296.139C58.4003,299.638,61.1627,302.991,64.106,306.183C82.6175,304.888,92.5839,301.039,102.137,297.358C109.488,294.525,116.905,291.665,128.541,289.82L128.634,290.414C117.065,292.246,109.679,295.092,102.355,297.917C93.028,301.518,83.8034,305.096,66.1535,306.48C65.8515,306.449,64.5013,306.253,64.1105,306.183C63.7698,306.159,63.4314,306.11,63.0979,306.036C60.3337,302.991,57.7433,299.794,55.3388,296.458C49.6046,288.615,45.1427,279.919,42.117,270.691C40.9178,270.859,39.7142,270.912,38.2708,271.023L38.2264,270.42C39.6121,270.318,40.7757,270.265,41.9349,270.105C41.7972,269.662,41.6684,269.218,41.5396,268.806C40.3493,268.97,39.159,269.028,37.7289,269.134L37.6845,268.531C39.0613,268.429,40.2161,268.376,41.3664,268.221C41.2687,267.866,41.1665,267.516,41.0733,267.161C39.8563,267.338,38.6439,267.392,37.1827,267.502L37.1382,266.899L37.1382,266.904ZM99.2814,250.244C110.829,248.914,110.562,237.868,119.601,234.946C110.74,234.897,107.267,247.805,99.2814,250.244ZM112.259,255.738C117.815,254.599,120.804,254.616,126.254,255.694C121.368,253.007,116.367,253.552,112.259,255.738ZM112.206,255.69C118.29,251.663,121.088,251.127,127.613,250.812C121.159,249.1,116.416,251.441,112.206,255.69ZM112.739,255.14C117.842,249.925,120.453,248.816,126.782,247.158C120.116,246.839,115.963,250.12,112.739,255.14Z"
              clip-rule="evenodd"
              fill="rgb(216,142,40)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U33"
              style={{ mixBlendMode: "multiply" }}
              d="M55.6274,202.895C51.1194,204.775,45.4789,208.93,43.6357,211.515C47.5841,216.122,61.3389,221.621,63.3686,225.066C72.3801,240.387,61.934,244.493,68.0142,256.443C69.8974,260.141,77.4876,262.735,88.058,264.868C99.0503,267.085,104.842,266.992,109.03,272.606C112.632,277.439,114.235,285.541,114.804,299.212C123.833,295.088,129.762,290.011,133.675,283.217C135.629,279.825,136.886,275.076,137.965,271.413C138.081,248.16,135.438,237.801,101.506,230.919C100.507,226.982,100.369,223.944,100.756,221.794L87.8537,212.327C71.1054,197.968,77.1412,193.933,55.6274,202.895Z"
              opacity="0.5"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U33-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U34"
              d="M72.6646,175.363C70.888,179.509,70.9769,180.405,69.2048,181.544C67.4327,182.684,63.4754,185.491,56.4981,184.68C54.9205,184.435,53.3163,184.412,51.7325,184.613C46.5095,185.331,43.8003,191.708,43.3695,196.958C42.8232,203.609,44.7863,210.567,50.8088,214.15C52.7141,215.285,69.4135,219.821,69.5556,234.139C82.0136,233.869,91.9666,224.712,96.71,199.109C97.8292,193.047,92.1043,191.57,91.2693,189.881C90.1768,187.664,90.6031,184.932,92.0554,179.961C92.2419,179.323,92.3449,178.662,92.3619,177.997C92.3715,176.453,92.0009,174.93,91.2827,173.563C88.0804,167.266,76.3686,166.676,72.6646,175.372L72.6646,175.363ZM69.5157,183.504C63.4177,187.411,52.4032,184.342,48.1573,188.794C46.1676,190.887,44.5598,194.359,45.2038,200.931C43.2629,194.985,46.4296,186.808,51.8658,185.549C53.313,185.226,54.8055,185.159,56.276,185.349C61.4635,185.766,65.1099,184.715,69.5157,183.504Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U34-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U35"
              d="M89.4214,175.455C88.6352,180.856,82.9859,180.39,81.4714,185.481C79.0331,183.264,78.3624,184.231,77.3232,185.884C77.1325,186.473,77.0089,187.082,76.9545,187.698C75.0137,189.388,69.8217,188.443,64.0746,190.022C55.8493,192.279,47.464,198.407,53.6109,212.424C48.4989,196.234,60.0641,191.933,68.4805,190.94C70.257,190.727,71.9847,190.589,73.6546,190.496C68.4494,191.139,64.6298,192.128,61.8895,193.33C56.7953,195.547,52.465,200.424,54.8367,209.563C57.1639,218.494,70.4124,218.135,70.8255,233.216C88.613,231.473,96.3365,212.628,93.9515,196.784C93.4807,193.68,90.5139,193.609,90.243,191.906C89.6656,188.328,90.6161,184.838,90.5717,184.275C90.3629,182.053,93.2276,179.543,89.4214,175.455Z"
              clip-rule="evenodd"
              fill="rgb(21,15,30)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U36"
              d="M91.9445,179.797C89.1065,188.457,92.7262,188.967,95.1823,191.326C101.791,197.68,97.5406,204.261,91.9712,210.642C95.0801,205.103,101.129,197.552,94.5294,191.632C92.0822,189.459,87.7741,190.076,91.9445,179.797Z"
              clip-rule="evenodd"
              fill="rgb(38,11,63)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U37"
              d="M91.989,180.059C88.7646,189.464,92.1134,188.896,94.5739,191.26C101.183,197.609,97.0655,202.86,91.949,210.642C95.058,205.103,101.107,197.552,94.5073,191.632C92.0823,189.459,87.8408,190.333,91.989,180.059Z"
              clip-rule="evenodd"
              fill="rgb(25,15,38)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U38"
              d="M68.3605,184.307C65.4115,185.456,60.6237,185.735,56.3423,186.108C47.9482,186.839,44.6127,190.333,45.3145,200.949C45.421,190.023,49.4404,187.265,58.0344,187.203C72.0069,187.092,72.2734,189.181,84.5048,177.199C79.7926,175.137,72.2201,182.808,68.3605,184.307Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U38-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U39"
              d="M151.072,287.098C154.394,291.39,156.926,294.898,161.838,297.811C165.258,299.842,167.114,300.471,167.612,303.988C167.923,306.13,165.391,306.396,162.251,305.761C159.786,305.256,157.432,303.256,155.922,301.899C153.906,300.09,152.476,300.378,151.245,299.274C149.265,297.5,148.505,292.055,147.692,289.519L151.072,287.098Z"
              clip-rule="evenodd"
              fill="rgb(32,49,98)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U40"
              d="M127.218,306.267C130.979,312.919,144.01,312.032,141.732,317.047C134.364,317.185,130.255,316.941,123.771,315.987C117.731,315.1,119.245,311.841,120.911,306.786L121.559,304.268L127.218,306.267Z"
              clip-rule="evenodd"
              fill="rgb(32,49,98)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U41"
              d="M96.2123,232.517C111.926,237.864,135.873,240.055,141.598,256.404C145.4,267.25,149.384,277.609,153.368,288.548C151.405,290.464,149.815,291.275,147.034,291.129C138.858,279.6,135.043,271.738,130.744,264.585C122.305,250.436,100.987,247.651,86.388,242.458L83.6699,231.098L96.2123,232.517Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U41-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <g
              id="eeV3ClaxE6U42"
              style={{ mixBlendMode: "multiply" }}
              opacity="0.3"
            >
              <path
                id="eeV3ClaxE6U43"
                d="M91.0562,236.392C106.765,241.74,129.696,245.261,136.567,261.566C138.259,265.556,143.024,280.291,147.048,291.129C138.872,279.6,135.057,271.738,130.757,264.585C122.319,250.436,101,247.651,86.4017,242.458L83.6836,231.098L91.0562,236.392Z"
                clip-rule="evenodd"
                fill="rgb(30,36,83)"
                fillRule="evenodd"
                stroke="none"
                strokeWidth="1"
              ></path>
            </g>
            <path
              id="eeV3ClaxE6U44"
              d="M74.361,236.002C70.8079,247.194,72.3402,255.699,84.7404,259.26C92.5305,261.477,102.11,262.834,106.69,264.137C113.458,266.08,117.149,265.468,118.068,273.95C119.29,285.191,120.453,295.426,120.267,306.764C122.971,307.726,125.232,307.691,128.026,306.893C128.821,296.769,129.9,284.132,130.579,274.633C131.676,259.304,129.398,257.952,119.685,252.657C109.585,247.154,98.6418,241.735,88.329,237.691L74.361,236.002Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U44-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <g
              id="eeV3ClaxE6U45"
              style={{ mixBlendMode: "multiply" }}
              opacity="0.3"
            >
              <path
                id="eeV3ClaxE6U46"
                d="M74.361,236.002C70.8079,247.194,72.3402,255.699,84.7404,259.26C92.5305,261.477,102.111,262.834,106.69,264.137C113.458,266.08,117.149,265.468,118.068,273.95C119.29,285.191,120.453,295.426,120.267,306.764C121.621,299.736,123.078,281.209,123.207,279.409C124.304,264.084,120.769,262.115,109.989,259.632C80.4901,252.834,76.595,246.835,77.4033,237.758L74.361,236.002Z"
                clip-rule="evenodd"
                fill="rgb(30,36,83)"
                fillRule="evenodd"
                stroke="none"
                strokeWidth="1"
              ></path>
            </g>
            <path
              id="eeV3ClaxE6U47"
              d="M105.478,197.312C107.552,195.716,107.725,195.738,107.911,193.104C107.941,192.03,108.14,190.968,108.502,189.956C109.004,188.799,109.701,188.626,109.701,190.816C109.874,192.883,109.559,192.767,111.722,191.876C112.983,191.353,113.881,191.663,115.275,192.044C116.004,192.24,117.962,193.042,118.233,193.308C118.944,194.018,118.553,195.14,117.109,194.452C116.267,194.059,115.39,193.746,114.489,193.517C115.377,194.151,115.719,193.96,115.79,194.319C116.012,195.446,115.879,197.472,115.12,198.754C113.725,201.064,111.26,199.414,109.932,199.698C109.017,199.889,108.458,200.43,106.139,201.955L105.478,197.312Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U47-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U48"
              d="M114.151,193.702C112.29,193.702,111.535,193.6,111.042,194.186C109.985,195.467,110.31,197.392,110.456,198.899C109.568,196.709,109.848,196.239,107.578,197.463C107.991,196.806,109.981,193.915,110.407,193.738C111.608,193.264,112.942,193.251,114.151,193.702Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U48-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U49"
              d="M78.8604,204.301C88.8579,224.77,101.027,210.305,109.244,200.434C108.839,198.009,107.738,196.603,106.006,196.098C99.5482,202.448,91.5315,208.749,87.0191,198.417C83.2795,191.854,76.5598,199.592,78.8604,204.301Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U49-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U50"
              style={{ mixBlendMode: "multiply" }}
              d="M78.8604,204.301C88.8579,224.77,101.027,210.367,109.244,200.497C104.474,204.594,101.374,206.381,99.3749,207.104C98.802,205.445,98.5355,204.443,96.6169,203.21C92.6197,204.811,89.6351,204.412,87.0191,198.417C83.2795,191.854,76.5598,199.592,78.8604,204.301Z"
              opacity="0.5"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U50-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U51"
              d="M86.0724,193.336C91.0733,196.276,93.5738,200.342,95.8433,203.308C98.2461,206.412,98.6947,209.516,97.4022,213.667C97.3001,219.99,97.0603,227.484,98.7346,233.213C92.1348,241.691,78.873,242.241,73.5833,237.989C74.9779,224.056,64.1455,210.319,67.854,200.998C69.9459,195.801,80.1654,189.868,86.0724,193.336Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U51-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U52"
              style={{ mixBlendMode: "multiply" }}
              d="M98.1222,209.152C98.2111,212.42,97.3361,216.597,97.3628,220.681C97.3628,222.162,97.3628,223.634,97.4827,225.066C95.0933,227.128,78.1451,239.256,69.409,212.14C68.1077,208.096,69.0626,201.498,75.5647,202.03C80.9787,202.474,84.5984,217.874,98.1222,209.152Z"
              opacity="0.5"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U52-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U53"
              d="M109.643,201.091C110.207,200.714,111.073,200.581,112.268,200.085C115.918,197.331,117.153,194.764,120.262,194.764C119.512,196.622,118.432,198.076,117.313,199.641C115.63,202.009,115.448,203.716,114.289,205.025C112.845,206.652,110.051,206.479,107.107,209.698L105.166,206.275C106.601,204.821,107.444,202.559,109.643,201.091Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U53-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U54"
              d="M110.807,201.122C111.429,200.86,111.366,200.612,112.561,200.115C116.207,197.361,117.042,195.397,119.316,194.918C118.695,196.39,116.354,199.197,115.235,200.776C113.552,203.144,113.143,202.368,111.984,203.676C111.984,203.676,109.212,204.119,108.431,204.563C108.884,203.37,108.933,201.915,110.807,201.122Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U54-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U55"
              d="M119.201,191.934C119.964,193.264,119.494,194.027,117.868,196.177C116.536,197.893,114.573,200.235,113.143,201.942C111.557,203.835,110.615,204.159,109.763,203.405C112.916,199.6,116.127,195.822,119.201,191.934Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U55-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U56"
              d="M108.422,204.572C109.785,202.643,110.145,201.96,112.237,200.86C114.458,198.04,115.124,197.614,117.02,197.344C115.524,198.86,114.538,201.126,113.303,202.7L111.429,204.572L109.035,206.509L108.422,204.572Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U56-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U57"
              d="M78.1761,204.452C81.1207,209.706,83.0615,213.839,86.1705,214.797C90.4519,216.127,95.3108,213.254,105.939,204.762C107.92,205.649,109.154,207.175,109.301,208.957C105.344,213.555,97.3582,222.517,90.3809,225.231C86.7256,226.654,83.2392,226.561,79.6861,224.051C75.3457,220.912,71.7481,216.86,69.1468,212.181C66.8551,207.919,65.5671,203.41,70.1062,199.987C72.4245,198.231,75.2936,199.348,78.1761,204.452Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U57-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U58"
              d="M79.1576,186.98C79.2217,189.573,78.6355,192.14,77.4521,194.448C79.2864,196.723,83.1859,196.448,84.3273,194.798C84.3273,193.619,84.2518,192.532,84.3007,191.331L79.1576,186.98Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U58-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U59"
              d="M89.5507,177.318C90.4417,179.174,90.6295,181.29,90.0792,183.274C89.9452,183.731,89.9452,184.217,90.0792,184.675C90.741,187.052,90.55,187.73,89.795,189.446C89.0399,191.162,88.96,192.027,88.276,192.55C87.5921,193.073,86.6416,193.078,85.8644,192.994C84.2655,192.856,81.6984,191.415,80.2416,190.333C79.1668,189.522,79.2734,189.091,78.9448,187.907C77.5013,186.227,78.7316,185.336,79.3001,185.309C80.9345,185.238,80.9212,187.083,81.805,187.646C82.1159,184.4,89.0533,179.881,89.5507,177.318Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U59-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U60"
              d="M90.0659,178.707C90.4871,180.2,90.4871,181.781,90.0659,183.274C89.932,183.732,89.932,184.218,90.0659,184.676C90.7277,187.052,90.5367,187.731,89.7817,189.447C89.453,190.196,89.2487,190.777,89.0666,191.265C88.8293,191.531,88.5046,191.703,88.1512,191.751C87.7979,191.799,87.4389,191.719,87.1391,191.527C86.5173,191.136,85.9844,190.258,86.0154,188.932C86.0154,187.992,84.2389,187.101,83.9724,186.103C83.7637,185.274,84.7674,184.534,85.367,184.166C87.4633,182.866,88.9378,180.902,90.0659,178.707Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U60-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U61"
              d="M89.5505,177.318C88.076,181.132,82.471,183.358,81.7959,187.637C83.8656,183.384,89.324,181.079,89.5505,177.318Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U61-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U62"
              d="M78.9222,187.854C81.8313,196.682,75.4002,199.666,72.4423,199.773C68.9869,199.897,65.3051,196.168,61.6543,200.172C67.0194,188.727,68.9114,197.13,78.9222,187.854Z"
              clip-rule="evenodd"
              fill="rgb(20,15,29)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U63"
              d="M75.5869,181.096C67.0284,185.331,63.995,185.69,64.9277,184.32C66.1265,182.484,67.7504,180.963,69.6621,179.886C72.2763,178.508,75.0368,177.427,77.8919,176.662L75.5869,181.096Z"
              clip-rule="evenodd"
              fill="rgb(70,133,198)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U64"
              d="M71.0967,182.94C69.7998,176.289,74.0502,170.44,79.251,168.498C85.2557,166.249,94.0317,168.737,93.0946,177.189C92.8292,176.747,92.3997,176.429,91.8999,176.302C92.5439,169.651,83.1593,169.708,84.3496,177.433L84.5139,177.397C79.8417,179.073,74.6586,182.053,71.0967,182.94Z"
              clip-rule="evenodd"
              fill="rgb(70,133,198)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U65"
              d="M71.0967,182.94C69.7998,176.289,74.0502,170.44,79.251,168.498C74.0946,171.332,74.6098,179.389,76.5107,180.887C74.7682,181.725,72.9569,182.412,71.0967,182.94Z"
              clip-rule="evenodd"
              fill="rgb(64,109,181)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U66"
              d="M76.5729,180.82C68.0411,185.028,64.0172,185.658,64.9321,184.306C65.776,184.598,69.942,183.175,76.3864,180L76.5729,180.82Z"
              clip-rule="evenodd"
              fill="rgb(83,149,208)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U67"
              d="M92.1625,176.352C91.9715,175.713,92.3624,175.075,92.0693,174.605C90.3194,173.966,84.3636,174.981,83.9549,175.691C83.8395,176.183,84.0615,176.786,84.3547,177.438C86.5087,176.755,89.5066,175.806,92.1625,176.352Z"
              clip-rule="evenodd"
              fill="rgb(70,133,198)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U68"
              d="M89.768,174.392C90.1194,174.354,90.4737,174.354,90.8251,174.392C91.4824,174.507,91.7133,174.755,91.7444,175.278C91.7888,175.89,91.4912,176.218,91.1359,176.21C90.6119,176.21,90.1544,176.21,89.6348,176.21L89.768,174.392Z"
              clip-rule="evenodd"
              fill="rgb(64,109,181)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U69"
              d="M89.1865,174.449C89.5763,174.395,89.9704,174.377,90.3635,174.396C91.7936,174.649,91.5138,176.112,90.852,176.17L89.3464,176.267L89.1865,174.449Z"
              clip-rule="evenodd"
              fill="rgb(70,133,198)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U70"
              d="M89.3903,175.084C89.3614,175.088,89.3336,175.098,89.3086,175.113C89.2836,175.128,89.2618,175.148,89.2445,175.172C89.2271,175.195,89.2146,175.222,89.2076,175.25C89.2006,175.278,89.1993,175.308,89.2037,175.337C89.2043,175.365,89.2106,175.394,89.2224,175.42C89.2342,175.446,89.2512,175.47,89.2724,175.489C89.2936,175.509,89.3185,175.524,89.3456,175.533C89.3727,175.543,89.4015,175.547,89.4302,175.545C89.4779,175.528,89.5184,175.495,89.5455,175.452C89.5726,175.409,89.5848,175.359,89.5803,175.308C89.5757,175.258,89.5547,175.21,89.5203,175.173C89.486,175.135,89.4403,175.11,89.3903,175.102L89.3903,175.084Z"
              clip-rule="evenodd"
              fill="rgb(64,109,181)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U71"
              d="M87.7164,175.34C87.6876,175.344,87.6598,175.354,87.6348,175.369C87.6098,175.384,87.588,175.404,87.5706,175.428C87.5533,175.451,87.5408,175.478,87.5338,175.506C87.5268,175.535,87.5255,175.564,87.5299,175.593C87.5333,175.651,87.5595,175.705,87.6027,175.744C87.6459,175.783,87.7027,175.804,87.7608,175.801C87.7895,175.797,87.8172,175.788,87.8422,175.773C87.8672,175.759,87.889,175.739,87.9064,175.716C87.9237,175.693,87.9363,175.667,87.9434,175.639C87.9504,175.611,87.9518,175.581,87.9474,175.553C87.9462,175.524,87.9394,175.495,87.9271,175.469C87.9149,175.442,87.8976,175.418,87.8761,175.399C87.8547,175.379,87.8295,175.364,87.8021,175.353C87.7747,175.343,87.7456,175.339,87.7164,175.34Z"
              clip-rule="evenodd"
              fill="rgb(64,109,181)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U72"
              d="M86.0016,175.717C85.9536,175.716,85.9063,175.729,85.866,175.755C85.8258,175.781,85.7944,175.819,85.7763,175.863C85.7581,175.908,85.754,175.956,85.7644,176.003C85.7749,176.05,85.7994,176.092,85.8347,176.125C85.87,176.157,85.9144,176.178,85.9619,176.185C86.0095,176.192,86.0579,176.183,86.1007,176.162C86.1435,176.14,86.1786,176.106,86.2014,176.064C86.2242,176.021,86.2335,175.973,86.2281,175.926C86.2275,175.897,86.2212,175.869,86.2094,175.842C86.1976,175.816,86.1806,175.793,86.1594,175.773C86.1382,175.754,86.1133,175.739,86.0862,175.729C86.0591,175.719,86.0303,175.715,86.0016,175.717Z"
              clip-rule="evenodd"
              fill="rgb(64,109,181)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U73"
              d="M92.1485,170.015C94.1605,170.552,94.8755,172.676,93.814,179.855C91.5934,172.1,87.1121,175.084,84.123,175.629C86.3881,167.138,96.1369,167.204,94.5513,173.576C94.649,171.55,93.6586,169.865,92.1485,170.015Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U73-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U74"
              d="M94.1916,176.732C94.1116,177.65,93.9872,178.688,93.814,179.836C91.5934,172.081,87.1121,175.065,84.123,175.61C84.555,173.862,85.4582,172.266,86.7345,170.994C86.4701,171.633,86.3797,172.331,86.4725,173.016C90.2299,172.16,93.6319,173.774,94.1249,177.379C94.1317,177.162,94.154,176.946,94.1916,176.732Z"
              clip-rule="evenodd"
              fill="rgb(20,15,29)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U75"
              style={{ mixBlendMode: "multiply" }}
              d="M185.159,222.676C213.657,222.676,236.758,217.928,236.758,212.07C236.758,206.212,213.657,201.463,185.159,201.463C156.661,201.463,133.56,206.212,133.56,212.07C133.56,217.928,156.661,222.676,185.159,222.676Z"
              opacity="0.35"
              fill="url(#eeV3ClaxE6U75-fill)"
              stroke="none"
              strokeWidth="1"
            ></path>
            <g
              id="eeV3ClaxE6U76"
              style={{ mixBlendMode: "multiply" }}
              opacity="0.35"
            >
              <path
                id="eeV3ClaxE6U77"
                style={{ mixBlendMode: "multiply" }}
                d="M220.561,236.028C275.322,236.028,319.714,231.279,319.714,225.421C319.714,219.563,275.322,214.814,220.561,214.814C165.8,214.814,121.408,219.563,121.408,225.421C121.408,231.279,165.8,236.028,220.561,236.028Z"
                opacity="0.35"
                fill="url(#eeV3ClaxE6U77-fill)"
                stroke="none"
                strokeWidth="1"
              ></path>
              <path
                id="eeV3ClaxE6U78"
                style={{ mixBlendMode: "multiply" }}
                d="M220.562,229.652C264.755,229.652,300.581,227.758,300.581,225.422C300.581,223.085,264.755,221.191,220.562,221.191C176.368,221.191,140.542,223.085,140.542,225.422C140.542,227.758,176.368,229.652,220.562,229.652Z"
                opacity="0.35"
                fill="url(#eeV3ClaxE6U78-fill)"
                stroke="none"
                strokeWidth="1"
              ></path>
            </g>
            <path
              id="eeV3ClaxE6U79"
              d="M134.27,156.003C139.995,150.048,148.163,147.241,161.571,137.379C166.441,133.849,170.714,129.565,174.229,124.688C182.667,112.911,191.492,108.977,200.086,110.316C208.467,111.647,216.617,117.948,223.914,126.905C251.197,160.397,246.774,199.569,214.618,215.276C194.308,225.2,147.11,219.178,133.32,198.616C127.617,190.111,122.589,168.17,134.27,156.003Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U79-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U80"
              style={{ mixBlendMode: "multiply" }}
              d="M204.128,111.332C211.079,113.731,217.794,119.394,223.914,126.901C251.197,160.393,246.774,199.565,214.618,215.271C200.215,222.308,172.297,221.324,152.355,212.832L152.138,212.739C144.05,209.263,137.295,204.545,133.32,198.612C131.437,195.809,129.629,191.539,128.47,186.639C137.752,196.47,168.886,208.026,204.923,180.83C213.037,174.707,218.154,164.973,216.253,155.449C214.956,148.957,211.123,143.786,209.662,127.331C209.311,123.393,209.662,116.56,204.128,111.332Z"
              opacity="0.3"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U80-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U81"
              d="M228.373,179.81C226.961,179.704,225.779,179.65,224.598,179.486C226.566,172.153,227.397,164.562,227.063,156.978C226.921,153.924,226.567,150.884,226.006,147.879C228.275,147.546,230.776,147.289,233.614,147.085C231.009,146.727,228.382,146.563,225.753,146.593C223.172,134.177,217.07,123.193,208.125,115.048C206.546,113.607,204.885,112.258,203.151,111.008L202.329,110.777C204.021,111.997,206.184,114.094,207.721,115.495C216.546,123.53,222.573,134.35,225.14,146.611C215.813,146.903,207.574,150.265,200.788,159.115C210.115,152.579,215.475,149.511,225.411,147.968C225.967,150.952,226.317,153.972,226.459,157.005C226.792,164.548,225.963,172.097,223.998,179.389C222.981,179.209,221.984,178.928,221.023,178.551L220.805,179.114C221.785,179.499,222.801,179.787,223.838,179.974C223.745,180.329,223.643,180.684,223.541,181.038C222.494,180.858,221.469,180.571,220.481,180.183L220.259,180.746C221.262,181.145,222.304,181.443,223.368,181.633C223.239,182.076,223.106,182.519,222.972,182.936C221.932,182.756,220.913,182.471,219.93,182.085L219.712,182.648C220.706,183.042,221.735,183.339,222.786,183.535C219.781,192.672,215.358,201.282,209.679,209.05C207.111,212.548,204.35,215.901,201.41,219.093C182.894,217.798,172.927,213.949,163.374,210.269C156.024,207.436,148.607,204.575,136.975,202.731L136.877,203.325C148.447,205.156,155.833,208.003,163.156,210.828C172.483,214.428,181.708,218.007,199.358,219.39C199.66,219.359,201.01,219.164,201.405,219.093C201.746,219.069,202.084,219.02,202.418,218.947C205.183,215.908,207.775,212.716,210.181,209.387C215.919,201.538,220.382,192.836,223.408,183.601C224.607,183.77,225.81,183.823,227.254,183.934L227.298,183.331C225.912,183.229,224.749,183.176,223.594,183.016C223.727,182.573,223.861,182.129,223.985,181.717C225.175,181.881,226.37,181.938,227.796,182.045L227.844,181.442C226.463,181.34,225.308,181.287,224.158,181.131C224.26,180.777,224.358,180.426,224.451,180.072C225.668,180.249,226.881,180.302,228.342,180.413L228.386,179.81L228.373,179.81ZM166.234,163.15C154.687,161.82,154.949,150.774,145.911,147.852C154.793,147.803,158.244,160.712,166.234,163.15ZM153.234,168.645C147.678,167.505,144.689,167.523,139.24,168.6C144.125,165.913,149.126,166.458,153.234,168.645ZM153.288,168.596C147.203,164.569,144.405,164.033,137.881,163.718C144.334,162.006,149.077,164.348,153.288,168.596ZM152.759,168.046C147.656,162.831,145.04,161.723,138.711,160.064C145.4,159.745,149.548,163.026,152.79,168.046L152.759,168.046Z"
              clip-rule="evenodd"
              fill="rgb(77,90,168)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U82"
              style={{ mixBlendMode: "multiply" }}
              d="M207.605,112.746C211.469,113.713,221.662,123.65,222.235,124.927C221.547,128.31,216.355,131.499,209.302,132.7C206.81,144.855,203.231,161.08,197.648,172.081C195.769,175.775,188.214,181.717,176.965,181.686C168.371,181.663,160.9,187.734,170.516,199.063C175.752,205.236,192.416,212.051,195.645,219.634C189.92,221.51,169.174,217.967,167.704,217.674C157.374,215.634,148.043,210.819,147.021,210.269C140.026,206.486,135.189,201.924,131.841,196.106C129.886,192.714,128.63,187.965,127.55,184.302C127.435,161.049,130.077,150.69,164.009,143.808C165.013,139.87,165.151,136.833,164.764,134.682L177.644,125.215C194.406,110.875,195.427,107.558,207.605,112.746Z"
              opacity="0.5"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U82-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U83"
              d="M162.877,206.274C164.285,206.904,165.742,207.055,166.706,207.702C168.624,208.997,169.482,211.511,167.701,213.564L156.055,226.978C152.294,222.468,160.186,217.799,158.321,211.418C157.939,210.123,161.674,205.747,162.877,206.274Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U83-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U84"
              d="M167.181,169.701C157.263,170.907,143.739,173.333,145.356,180.973C147.288,190.094,155.367,198.541,162.317,206.319C163.783,207.964,160.883,212.443,158.511,210.988C147.981,204.541,136.615,196.484,133.053,189.704C129.904,183.727,129.918,178.286,132.272,173.244C136.296,164.633,158.427,149.84,172.492,143.942C176.574,143.317,183.769,138.799,186.465,141.526C188.241,143.299,187.047,151.543,186.873,154.443C186.647,158.105,185.541,161.537,183.542,164.14C179.532,169.289,173.008,168.991,167.181,169.701Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U84-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U85"
              d="M167.181,169.699C157.264,170.906,143.74,173.331,145.356,180.971C147.288,190.093,154.412,202.597,161.345,210.375C161.229,210.51,161.091,210.624,160.937,210.712C154.419,207.332,148.522,202.875,143.495,197.529C138.237,191.858,137.682,184.346,138.61,177.007C139.01,173.903,137.477,171.079,134.901,169.358C140.169,162.609,149.478,157.479,158.343,152.69C162.935,150.211,181.438,136.491,186.439,141.537C188.215,143.311,187.02,151.554,186.847,154.454C186.621,158.117,185.515,161.549,183.516,164.152C179.532,169.287,173.008,168.99,167.181,169.699Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U85-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U86"
              d="M176.712,212.496C178.156,213.041,179.612,213.117,180.612,213.711C182.601,214.895,183.592,217.365,181.944,219.511L171.049,233.541C167.052,229.244,174.674,224.149,172.457,217.884C171.991,216.611,175.486,212.03,176.712,212.496Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U86-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U87"
              d="M178.994,175.739C169.166,177.486,155.788,180.648,157.827,188.191C160.256,197.192,168.788,205.183,176.156,212.579C177.711,214.14,175.059,218.787,172.603,217.457C161.735,211.595,147.327,200.607,143.397,194.053C130.233,172.072,163.827,155.435,182.88,149.759C186.922,148.912,193.859,143.994,196.702,146.58C198.572,148.269,197.834,156.548,197.817,159.439C197.817,163.106,196.893,166.618,195.027,169.301C191.306,174.653,184.768,174.711,178.994,175.739Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U87-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U88"
              d="M178.994,175.74C169.166,177.488,155.788,180.649,157.827,188.192C160.256,197.193,168.788,205.184,176.156,212.58C171.351,210.159,158.049,199.278,152.337,189.309C150.605,186.29,144.552,182.365,141.723,177.616C147.221,163.928,168.957,153.906,182.885,149.751C186.927,148.904,193.864,143.987,196.706,146.572C198.576,148.261,197.839,156.54,197.821,159.431C197.821,163.098,196.897,166.61,195.032,169.293C191.306,174.654,184.768,174.712,178.994,175.74Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U88-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U89"
              d="M135.105,165.47C141.652,161.098,169.042,142.182,179.754,138.816C183.165,137.743,183.418,139.934,185.528,141.539C187.408,142.963,188.839,144.896,189.65,147.108C192.465,145.96,195.179,145.179,196.707,146.563C198.577,148.252,197.839,156.531,197.822,159.422C197.822,163.089,196.898,166.601,195.032,169.284C191.306,174.636,184.777,174.694,178.995,175.723C169.166,177.47,159.626,181.141,161.674,188.684C143.908,182.942,139.347,167.595,135.105,165.47Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U89-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U90"
              d="M193.65,159.239L173.451,170.684C173.123,170.919,172.967,170.706,172.758,170.116L144.933,153.936C144.711,153.492,144.667,152.969,145.986,152.29L164.284,142.127C165.479,141.684,166.261,141.542,167.22,142.047L194.685,157.124L194.685,158.011C194.779,158.396,194.352,158.867,193.65,159.239Z"
              clip-rule="evenodd"
              fill="rgb(61,153,212)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U91"
              d="M193.65,158.232L173.451,169.682C173.123,169.912,172.967,169.682,172.758,169.11L144.933,152.929C144.711,152.486,144.667,151.967,145.986,151.284L164.284,141.121C165.479,140.677,166.261,140.54,167.22,141.045L194.445,156.667C195.014,157.102,194.539,157.749,193.65,158.232Z"
              clip-rule="evenodd"
              fill="rgb(59,194,210)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U92"
              d="M187.033,160.197L171.658,168.915C171.409,169.088,171.289,168.915,171.129,168.471L146.258,154.016C146.089,153.661,146.058,153.28,147.061,152.765L160.989,145.023C161.878,144.677,162.495,144.58,163.21,144.965L187.637,158.995C188.059,159.337,187.713,159.829,187.033,160.197Z"
              clip-rule="evenodd"
              fill="rgb(61,153,212)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U93"
              d="M186.856,80.7981C191.297,77.1265,194.584,78.5809,197.657,81.6317C200.877,84.8244,201.681,86.6956,203.524,87.7022C206.633,89.4005,209.649,87.9816,216.209,86.505C227.756,83.9065,231.527,94.3935,230.514,102.965C229.311,113.133,220.015,122.476,211.585,126.254C201.157,130.936,196.343,126.746,194.206,120.573C192.799,116.503,193.38,113.386,192.572,111.869C189.29,105.719,183.987,109.443,181.402,102.18C179.963,98.1316,183.001,94.1009,181.029,89.0414C173.55,81.0464,182.504,78.5056,186.856,80.7981Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U93-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U94"
              d="M230.63,101.669C230.603,102.112,230.563,102.555,230.514,102.963C229.311,113.131,220.015,122.474,211.585,126.252C201.157,130.935,196.343,126.744,194.206,120.572C192.798,116.501,193.38,113.384,192.572,111.867C189.29,105.717,183.987,109.442,181.402,102.178C179.963,98.13,183.001,94.0992,181.029,89.0397C180.882,88.8845,180.745,88.7293,180.611,88.5963C183.325,88.5475,186.501,87.0089,189.663,84.1133C191.208,86.0378,191.883,88.4633,192.772,90.7647C194.753,88.685,195.978,90.2326,196.907,92.7423C198.239,96.3784,198.634,97.2033,200.016,97.4383C208.805,98.906,209.667,99.4425,217.963,104.839C223.945,108.715,226.193,106.803,230.63,101.669Z"
              clip-rule="evenodd"
              fill="rgb(36,9,61)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U95"
              d="M189.254,101.19C184.51,101.092,182.032,101.54,180.233,104.01C178.013,105.7,176.205,108.09,174.624,111.021C171.635,116.564,169.401,123.596,166.359,128.665C161.864,136.154,161.473,137.64,153.736,144.925C154.741,145.753,155.415,146.915,155.633,148.198C164.44,143.803,169.703,141.693,172.954,137.662C176.205,133.631,177.839,129.387,179.079,126.173C178.728,130.456,177.262,136.757,174.717,140.278C180.598,151.643,194.055,152.667,198.363,156.716C200.926,151.967,204.736,140.881,205.82,130.802C206.264,126.718,208.693,119.761,207.334,113.854C205.22,104.746,197.821,101.398,189.254,101.19Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U95-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <g
              id="eeV3ClaxE6U96"
              style={{ mixBlendMode: "multiply" }}
              opacity="0.5"
            >
              <path
                id="eeV3ClaxE6U97"
                d="M178.146,144.979C180.811,148.682,188.246,152.074,190.542,152.704C196.547,149.924,202.307,146.766,204.71,137.88C205.248,135.393,205.598,132.559,205.798,130.785C206.14,127.624,206.065,122.511,205.385,117.62C204.106,114.073,201.046,111.722,197.6,113.629C194.766,115.177,192.345,126.151,191.408,128.058C188.739,133.503,185.692,137.605,178.146,144.979Z"
                clip-rule="evenodd"
                fill="rgb(237,107,168)"
                fillRule="evenodd"
                stroke="none"
                strokeWidth="1"
              ></path>
            </g>
            <path
              id="eeV3ClaxE6U98"
              d="M193.593,97.0273C193.997,99.8298,194.135,100.606,195.236,103.315C194.899,106.087,190.213,107.749,188.37,103.346C188.543,102.243,188.499,101.116,188.241,100.029L190.218,97.9852L193.593,97.0273Z"
              clip-rule="evenodd"
              fill="rgb(248,165,152)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U99"
              d="M193.371,95.5449C193.491,96.3653,193.815,98.4937,193.913,99.0702C193.309,100.635,190.759,102.72,188.477,102.343C188.488,101.565,188.409,100.788,188.241,100.028L190.218,97.9838L193.371,95.5449Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U99-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U100"
              d="M180.42,90.2028C181.37,94.5572,181.81,98.2155,184.311,101.027C186.451,103.439,188.374,102.561,190.138,100.929C191.901,99.2975,192.86,98.2687,193.753,96.0516C194.197,95.6082,194.77,95.4086,195.174,94.6371C195.774,93.493,195.867,91.7415,194.854,90.9211C194.41,90.5575,193.744,91.1162,193.5,92.1317C193.189,93.3999,192.509,92.4509,192.265,91.6883C191.594,89.5642,190.622,88.4069,189.538,86.3184C187.126,88.5931,183.915,91.5597,180.42,90.2028Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U100-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U101"
              d="M180.42,90.2028C180.571,90.8857,180.709,91.5331,180.842,92.1982C184.071,92.4066,186.958,90.8679,189.418,87.5467C190.684,89.2938,190.75,90.9522,191.603,92.2204C192.278,93.258,192.936,93.6172,193.531,93.1738C194.392,92.5441,194.059,91.9277,195.165,91.2493C195.076,91.1273,194.971,91.0171,194.854,90.9211C194.41,90.5575,193.744,91.1162,193.5,92.1317C193.189,93.3999,192.509,92.451,192.265,91.6883C191.594,89.5642,190.622,88.4069,189.538,86.3184C187.126,88.5931,183.915,91.5597,180.42,90.2028Z"
              clip-rule="evenodd"
              fill="rgb(248,165,152)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U102"
              d="M182.596,90.6546C186.011,90.2112,190.497,86.6638,189.676,83.4578C188.921,80.5135,185.008,79.5424,182.005,79.8661C173.776,80.7529,175.117,91.5947,182.596,90.6546Z"
              clip-rule="evenodd"
              fill="rgb(90,46,105)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U103"
              d="M182.596,90.654C185.736,90.2638,189.783,87.2175,189.774,84.2376L189.663,84.0957C184.813,88.53,179.918,89.7804,176.729,87.3682C177.498,89.4434,179.532,91.0398,182.596,90.654Z"
              clip-rule="evenodd"
              fill="rgb(36,9,61)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U104"
              d="M177.422,148.855C177.289,148.895,174.957,149.742,174.757,149.818C174.366,150.008,173.909,150.261,173.607,150.363C171.062,151.277,168.148,151.56,167.624,151.884C166.736,152.447,163.876,153.973,163.352,154.638C162.908,155.205,162.521,155.649,161.193,157.449C160.554,158.336,161.864,158.531,162.024,158.46C162.797,158.128,163.303,156.748,164.284,155.964C164.993,155.44,165.755,154.994,166.558,154.633C165.541,155.551,164.955,155.964,164.573,156.482C164.03,157.288,163.583,158.154,163.241,159.063C162.912,159.884,163.685,160.3,163.956,160.025C164.618,159.369,165.248,158.092,165.839,157.325C166.829,156.819,167.287,156.438,168.397,155.87L166.536,157.746L165.155,160.203C164.711,161.09,165.515,161.453,166.008,160.97C166.501,160.487,167.078,159.453,167.624,158.682C168.224,158.278,169.063,157.52,169.907,156.846L168.837,158.482C168.348,159.044,167.914,159.652,167.54,160.296C167.322,160.739,167.726,161.271,168.428,160.651C168.961,160.176,169.73,159.351,169.969,159.103C171.231,157.684,171.941,157.631,172.865,156.957C173.935,156.172,175.201,154.429,176.329,153.746C177.27,153.271,178.249,152.875,179.256,152.563L177.422,148.855Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U104-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U105"
              d="M173.594,150.202C175.13,150.646,175.814,152.925,175.663,154.335C184.932,151.417,192.341,149.51,199.815,142.642C205.909,137.05,210.297,117.216,206.166,110.875C204.137,107.771,195.818,112.05,195.29,118.227C194.535,127.029,194.153,130.31,189.605,136.762C185.306,142.863,180.869,146.859,173.594,150.202Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U105-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U106"
              d="M132.564,129.064C132.858,128.895,133.097,128.647,133.391,128.483C133.55,128.319,134.168,128.665,134.945,129.13L160.447,144.446C162.224,145.497,161.979,145.178,162.903,147.018C166.48,154.148,170.051,161.286,173.616,168.431C174.087,169.487,174.326,170.041,174.184,170.165L173.318,170.777L132.564,129.064Z"
              clip-rule="evenodd"
              fill="rgb(59,194,210)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U107"
              d="M162.055,147.618L172.777,169.031C173.665,171.018,173.718,171.248,171.999,170.131L146.098,154.611C144.49,153.653,144.765,153.724,143.917,152.066L132.956,130.285C131.943,128.511,132.791,128.954,134.106,129.744L159.608,145.06C161.367,146.102,161.131,145.782,162.055,147.618Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U107-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U108"
              d="M148.793,139.968C149.011,139.888,149.424,140.132,149.717,140.505C150.01,140.877,150.072,141.245,149.855,141.325C149.637,141.405,149.224,141.161,148.931,140.784C148.638,140.407,148.589,140.044,148.793,139.968Z"
              clip-rule="evenodd"
              fill="rgb(50,112,184)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U109"
              d="M149.034,140.26C149.158,140.216,149.394,140.353,149.558,140.566C149.722,140.779,149.758,140.983,149.633,141.01C149.509,141.036,149.278,140.917,149.109,140.708C148.941,140.5,148.914,140.305,149.034,140.26Z"
              clip-rule="evenodd"
              fill="rgb(45,52,133)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U110"
              d="M149.132,140.372C149.216,140.345,149.372,140.434,149.483,140.58C149.594,140.727,149.62,140.86,149.536,140.891C149.451,140.922,149.296,140.829,149.185,140.687C149.074,140.545,149.047,140.416,149.132,140.372Z"
              clip-rule="evenodd"
              fill="rgb(77,90,168)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U111"
              d="M149.237,140.5C149.286,140.5,149.37,140.535,149.432,140.615C149.495,140.695,149.508,140.77,149.464,140.788C149.419,140.806,149.33,140.753,149.268,140.673C149.206,140.593,149.175,140.518,149.237,140.5Z"
              clip-rule="evenodd"
              fill="rgb(255,255,255)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U112"
              d="M211.829,117.482C209.218,118.369,208.689,118.884,205.94,118.689C203.426,118.507,202.56,118.768,200.49,120.019C199.75,120.486,198.961,120.869,198.136,121.163C196.804,121.491,195.063,121.837,194.17,122.147C191.559,123.034,192.811,124.489,195.147,124.12L199.264,123.469C201.605,126.302,200.926,127.872,203.364,127.743C205.074,127.576,206.729,127.052,208.223,126.205C210.972,124.431,208.773,124.196,213.725,122.4C213.397,119.815,213.357,119.611,211.829,117.482Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U112-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U113"
              d="M207.139,118.803C206.411,119.845,203.475,121.149,203.364,122.107C203.306,122.24,203.706,122.444,205.14,123.038C205.263,123.087,205.374,123.159,205.468,123.251C205.561,123.343,205.636,123.453,205.687,123.575C205.737,123.696,205.763,123.826,205.763,123.957C205.763,124.089,205.737,124.219,205.686,124.34C205.635,124.461,205.56,124.57,205.466,124.662C205.372,124.754,205.261,124.827,205.138,124.875C205.016,124.924,204.885,124.947,204.754,124.945C204.622,124.942,204.492,124.913,204.372,124.86C201.539,123.672,200.686,123.37,201.379,121.756C201.792,120.346,202.049,119.242,202.622,118.781C203.666,117.903,205.922,118.643,207.139,118.803Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U113-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U114"
              d="M203.826,123.65C204.054,123.581,204.3,123.596,204.518,123.693C204.736,123.79,204.911,123.962,205.012,124.177C205.113,124.393,205.133,124.638,205.068,124.867C205.002,125.096,204.857,125.294,204.657,125.424L201.668,126.79C201.429,126.9,201.157,126.912,200.91,126.822C200.663,126.731,200.462,126.547,200.351,126.309C200.24,126.071,200.229,125.798,200.319,125.552C200.41,125.305,200.594,125.105,200.833,124.994L203.826,123.65Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U114-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U115"
              d="M204.395,125.659C204.497,125.612,204.609,125.585,204.722,125.581C204.835,125.576,204.948,125.594,205.055,125.633C205.161,125.672,205.259,125.732,205.342,125.809C205.426,125.886,205.493,125.978,205.54,126.081C205.588,126.184,205.615,126.295,205.619,126.408C205.624,126.521,205.606,126.634,205.567,126.74C205.528,126.846,205.468,126.944,205.391,127.027C205.314,127.11,205.221,127.177,205.118,127.225L202.507,128.409C202.296,128.497,202.058,128.499,201.845,128.417C201.631,128.334,201.458,128.172,201.361,127.965C201.313,127.863,201.287,127.752,201.282,127.639C201.277,127.526,201.295,127.414,201.334,127.308C201.374,127.202,201.433,127.105,201.51,127.022C201.587,126.939,201.68,126.872,201.783,126.826L204.395,125.659Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U115-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U116"
              d="M202.533,121.938C202.652,121.861,202.786,121.811,202.926,121.79C203.065,121.769,203.208,121.779,203.344,121.818C203.479,121.856,203.605,121.924,203.713,122.015C203.821,122.107,203.907,122.22,203.967,122.348C204.028,122.475,204.06,122.614,204.061,122.755C204.063,122.896,204.035,123.036,203.978,123.165C203.921,123.294,203.838,123.41,203.732,123.504C203.627,123.598,203.503,123.669,203.368,123.711L200.375,125.073C200.147,125.142,199.901,125.127,199.683,125.03C199.466,124.933,199.29,124.761,199.189,124.546C199.088,124.33,199.068,124.085,199.134,123.856C199.199,123.627,199.345,123.429,199.544,123.299L202.533,121.938Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U116-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U117"
              d="M208.587,118.054C247.449,100.809,233.498,81.3916,251.557,72.8689C262.216,68.5632,259.449,77.9683,257.299,83.1032C253.595,91.9362,251.646,99.2971,244.682,107.283C236.741,116.391,224.083,120.692,211.567,123.69C209.595,121.721,208.849,120.103,208.587,118.054Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U117-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U118"
              style={{ mixBlendMode: "multiply" }}
              d="M250.056,78.293C250.806,80.2041,254.275,86.0042,255.181,87.8444C254.315,92.7221,248.346,102.531,246.387,105.138C242.15,110.774,236.678,114.366,230.62,117.372C224.731,120.294,218.185,122.09,211.562,123.687C241.679,111.142,246.88,89.5072,250.056,78.293Z"
              opacity="0.3"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U118-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U119"
              d="M272.955,225.066C270.41,227.075,269.544,227.917,266.293,227.984C263.628,228.037,262.74,227.385,261.266,226.21C259.609,224.924,259.098,224.117,259.129,222.973C259.191,220.792,260.399,218.823,260.586,216.091L265.889,216.406L268.198,215.439C269.202,216.717,271.334,219.076,272.831,221.146C273.595,222.162,273.306,223.984,272.955,225.066Z"
              clip-rule="evenodd"
              fill="rgb(31,50,99)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <g
              id="eeV3ClaxE6U120"
              style={{ mixBlendMode: "multiply" }}
              opacity="0.5"
            >
              <path
                id="eeV3ClaxE6U121"
                d="M260.009,219.116C260.315,218.131,260.513,217.115,260.599,216.087L265.902,216.402L268.212,215.436C268.607,215.937,269.176,216.606,269.815,217.36C267.701,219.395,261.332,220.446,260.009,219.116Z"
                clip-rule="evenodd"
                fill="rgb(31,50,99)"
                fillRule="evenodd"
                stroke="none"
                strokeWidth="1"
              ></path>
            </g>
            <path
              id="eeV3ClaxE6U122"
              d="M233.424,214.052C233.868,216.207,235.2,217.857,235.387,219.444C235.742,222.176,234.165,224.92,230.945,224.951L209.773,225.138C210.893,217.914,222.209,221.918,226.015,213.91L230.941,214.19L233.424,214.052Z"
              clip-rule="evenodd"
              fill="rgb(31,50,99)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <g
              id="eeV3ClaxE6U123"
              style={{ mixBlendMode: "multiply" }}
              opacity="0.5"
            >
              <path
                id="eeV3ClaxE6U124"
                d="M233.423,214.052C233.569,214.727,233.783,215.385,234.063,216.016C232.078,217.391,228.249,218.318,223.821,216.801C224.739,215.998,225.48,215.014,225.998,213.91L230.923,214.19L233.423,214.052Z"
                clip-rule="evenodd"
                fill="rgb(31,50,99)"
                fillRule="evenodd"
                stroke="none"
                strokeWidth="1"
              ></path>
            </g>
            <path
              id="eeV3ClaxE6U125"
              d="M245.419,123.078C238.957,154.495,234.164,183.136,224.46,214.207C226.539,216.349,232.503,216.238,235.119,215.488C249.509,180.591,260.173,164.818,266.768,126.359L245.419,123.078Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U125-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U126"
              style={{ mixBlendMode: "multiply" }}
              d="M257.162,122.994C255.128,141.525,250.38,157.515,246.25,173.372C243.612,183.491,239.446,194.16,235.146,215.471C249.536,180.573,260.2,164.8,266.795,126.342L257.162,122.994Z"
              opacity="0.3"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U126-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U127"
              d="M277.104,122.351C279.658,133.206,280.626,135.157,280.431,140.678C280.049,151.457,277.85,163.873,275.816,176.289C273.538,190.036,271.375,202.567,270.153,216.473C266.129,218.783,263.047,218.029,259.809,216.264C260.254,203.05,260.431,189.96,260.56,176.799C260.769,155.958,257.167,141.01,253.01,121.176L277.104,122.351Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U127-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U128"
              d="M281.891,133.006C280.985,135.724,279.836,138.355,278.458,140.868C277.285,138.819,276.188,136.717,274.847,134.771L272.058,136.411C269.393,137.986,267.91,136.7,271.134,133.751C273.106,131.937,275.078,130.266,277.205,128.479L281.891,133.006Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U128-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U129"
              d="M281.891,133.007C281.336,134.573,280.901,135.739,280.417,136.87C278.929,134.883,276.863,130.631,276.335,129.198L277.223,128.467L281.891,133.007Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U129-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U130"
              d="M274.874,134.744C276.611,137.609,278.192,140.438,280.088,143.205L279.12,145.701C276.815,142.216,274.91,139.662,272.969,135.906L274.874,134.744Z"
              clip-rule="evenodd"
              fill="rgb(31,65,127)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U131"
              d="M281.843,134.416L276.22,128.252C284.046,113.801,289.908,105.243,275.527,96.7689C275.625,106.861,277.246,115.246,277.912,124.993C277.592,125.62,277.233,126.228,276.838,126.811C267.382,131.374,253.356,131.338,243.461,127.255C244.647,117.974,246.663,106.005,245.837,96.8709C245.985,92.9157,245.907,88.9554,245.602,85.0092C244.687,75.0277,254.04,70.6909,262.408,71.0279C274.537,71.5113,278.956,76.5663,286.924,85.4349C292.729,91.8912,298.751,100.667,298.218,105.979C297.792,110.293,296.015,115.357,281.843,134.416Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U131-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <g
              id="eeV3ClaxE6U132"
              style={{ mixBlendMode: "multiply" }}
              opacity="0.35"
            >
              <path
                id="eeV3ClaxE6U133"
                d="M281.842,134.416L276.22,128.253C276.948,126.922,277.13,126.612,277.81,125.366C282.482,127.233,291.325,122.546,298.24,106.006C297.791,110.294,296.015,115.358,281.842,134.416Z"
                clip-rule="evenodd"
                fill="rgb(190,209,230)"
                fillRule="evenodd"
                stroke="none"
                strokeWidth="1"
              ></path>
            </g>
            <path
              id="eeV3ClaxE6U134"
              d="M265.6,64.7773C265.769,67.2183,266.076,69.6477,266.52,72.054C265.578,75.3487,262.447,77.885,259.387,77.4682C256.749,77.1135,256.109,73.1803,257.011,70.9809C257.131,69.9681,257.201,68.9499,257.22,67.9301L263.882,65.9879L265.6,64.7773Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U134-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U135"
              d="M266.294,62.7375C268.026,62.5823,268.288,61.9083,268.364,60.7021C268.439,59.496,268.492,59.7843,268.945,58.72C269.148,58.2585,269.274,57.7673,269.318,57.2656C269.456,55.7269,268.914,54.9642,268.635,53.8867C268.284,52.5564,268.719,51.8824,268.714,50.9512C268.714,46.4593,264.069,43.8298,260.693,46.8495C258.562,44.7077,256.296,45.2887,254.582,47.0402C251.784,46.2686,249.532,47.0757,248.435,49.3859C246.308,53.869,250.265,56.627,252.699,56.9818L260.96,59.9306L266.294,62.7375Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U135-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U136"
              d="M266.293,62.7362C268.025,62.581,268.287,61.9069,268.363,60.7008C268.438,59.4947,268.492,59.7829,268.945,58.7187C269.147,58.2572,269.273,57.766,269.318,57.2643C269.456,55.7256,268.914,54.9629,268.634,53.8854L268.634,53.841C268.105,55.8852,266.031,56.8342,265.13,54.4264C264.51,54.2047,263.941,53.8603,263.458,53.4137C262.975,52.9672,262.587,52.4277,262.318,51.8278C261.688,50.3202,260.782,49.6418,259.169,50.6306C255.434,52.9187,252.712,55.9739,248.19,53.5972C249.025,55.5704,251.171,56.7543,252.712,56.9805L260.973,59.9293L266.293,62.7362Z"
              clip-rule="evenodd"
              fill="rgb(20,15,29)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U137"
              d="M251.743,56.7279C252.631,61.0646,253.2,65.5964,255.994,69.1882C257.006,70.4919,258.214,71.1349,260.377,69.9997C261.877,69.1227,263.3,68.1215,264.632,67.0066C266.613,65.4679,266.035,64.6653,266.195,63.7784C266.29,63.3403,266.439,62.9158,266.639,62.5146C267.23,61.2331,268.527,60.1955,268.172,58.7144C267.843,57.3576,266.626,56.9407,266.364,57.9917C266.004,59.4816,264.965,62.12,264.299,54.9852C262.651,54.3378,262.274,54.0052,261.603,52.9987C260.932,51.9921,260.328,51.2649,259.227,52.3203C256.953,54.4842,255.043,56.5106,251.743,56.7279Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U137-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U138"
              d="M251.743,56.7288C251.832,57.1723,251.916,57.5758,252.001,58.0059C256.34,57.5625,257.894,55.1502,260.062,52.7336C261.47,54.086,261.838,54.5073,263.562,55.4207C263.659,55.8997,263.908,58.6533,264.601,59.855C265.169,60.8217,265.685,60.5157,266.111,59.7087C266.395,59.1721,266.75,57.0038,267.852,58.0015C267.363,57.2521,266.555,57.1545,266.351,58.0015C265.991,59.4914,264.952,62.1298,264.286,54.995C262.638,54.3476,262.26,54.0151,261.59,53.0085C260.919,52.0019,260.315,51.2747,259.214,52.33C256.953,54.4851,255.043,56.5116,251.743,56.7288Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U138-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <g
              id="eeV3ClaxE6U139"
              style={{ mixBlendMode: "multiply" }}
              opacity="0.35"
            >
              <path
                id="eeV3ClaxE6U140"
                style={{ mixBlendMode: "multiply" }}
                d="M287.541,321.251C338.093,321.251,379.073,316.502,379.073,310.644C379.073,304.786,338.093,300.037,287.541,300.037C236.99,300.037,196.01,304.786,196.01,310.644C196.01,316.502,236.99,321.251,287.541,321.251Z"
                opacity="0.35"
                fill="url(#eeV3ClaxE6U140-fill)"
                stroke="none"
                strokeWidth="1"
              ></path>
              <path
                id="eeV3ClaxE6U141"
                style={{ mixBlendMode: "multiply" }}
                d="M287.541,314.875C328.339,314.875,361.409,312.981,361.409,310.644C361.409,308.308,328.339,306.414,287.541,306.414C246.743,306.414,213.673,308.308,213.673,310.644C213.673,312.981,246.743,314.875,287.541,314.875Z"
                opacity="0.35"
                clip-rule="evenodd"
                fill="url(#eeV3ClaxE6U141-fill)"
                fillRule="evenodd"
                stroke="none"
                strokeWidth="1"
              ></path>
            </g>
            <path
              id="eeV3ClaxE6U142"
              d="M261.16,245.593C266.884,239.637,275.052,236.83,288.465,226.969C293.333,223.439,297.605,219.154,301.118,214.278C309.557,202.5,318.382,198.567,326.976,199.906C335.361,201.237,343.506,207.538,350.804,216.495C378.087,249.983,373.663,289.159,341.512,304.865C321.198,314.785,274.004,308.768,260.209,288.206C254.498,279.697,249.439,257.76,261.16,245.593Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U142-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U143"
              style={{ mixBlendMode: "multiply" }}
              d="M330.995,200.918C337.946,203.321,344.666,208.979,350.781,216.491C378.064,249.979,373.641,289.155,341.49,304.862C327.087,311.894,299.168,310.914,279.222,302.418L279.009,302.33C270.922,298.849,264.162,294.131,260.187,288.202C258.308,285.395,256.496,281.107,255.337,276.23C264.619,286.056,295.753,297.616,331.795,270.416C339.909,264.297,345.025,254.559,343.12,245.035C341.823,238.547,337.99,233.377,336.529,216.921C336.178,212.984,336.529,206.15,330.995,200.918Z"
              opacity="0.3"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U143-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U144"
              d="M355.244,269.41C353.828,269.303,352.646,269.25,351.465,269.082C353.434,261.749,354.267,254.158,353.934,246.573C353.787,243.52,353.434,240.48,352.877,237.474C355.142,237.146,357.643,236.884,360.481,236.68C357.876,236.324,355.248,236.161,352.62,236.193C350.039,223.777,343.941,212.793,334.996,204.647C333.416,203.208,331.755,201.86,330.022,200.608L329.196,200.377C330.893,201.596,333.051,203.694,334.588,205.091C343.413,213.13,349.44,223.95,352.007,236.206C342.68,236.499,334.446,239.86,327.655,248.715C336.982,242.179,342.342,239.11,352.278,237.567C352.835,240.552,353.187,243.571,353.33,246.604C353.66,254.14,352.832,261.681,350.874,268.966C349.857,268.786,348.86,268.505,347.898,268.128L347.685,268.687C348.665,269.077,349.681,269.366,350.719,269.552C350.621,269.906,350.523,270.261,350.421,270.616C349.373,270.436,348.346,270.149,347.357,269.76L347.139,270.319C348.142,270.721,349.184,271.018,350.248,271.206C350.119,271.649,349.99,272.092,349.853,272.509C348.812,272.327,347.793,272.041,346.81,271.653L346.593,272.217C347.585,272.613,348.615,272.91,349.666,273.103C346.664,282.24,342.241,290.849,336.56,298.614C333.993,302.114,331.232,305.469,328.29,308.662C309.774,307.367,299.808,303.518,290.259,299.838C282.904,297,275.487,294.144,263.855,292.299L263.762,292.898C275.309,294.729,282.717,297.576,290.037,300.396C299.364,304.001,308.588,307.58,326.238,308.963C326.54,308.932,327.89,308.737,328.286,308.666C328.624,308.638,328.961,308.589,329.294,308.52C332.06,305.481,334.654,302.289,337.062,298.96C342.795,291.115,347.255,282.418,350.279,273.188C351.478,273.361,352.682,273.414,354.125,273.52L354.17,272.922C352.784,272.815,351.62,272.766,350.466,272.607C350.599,272.163,350.732,271.72,350.861,271.303C352.047,271.472,353.241,271.525,354.672,271.636L354.716,271.033C353.339,270.931,352.18,270.877,351.03,270.718C351.132,270.367,351.229,270.013,351.327,269.662C352.54,269.835,353.757,269.893,355.213,270.004L355.262,269.401L355.244,269.41ZM293.101,252.737C281.554,251.407,281.82,240.365,272.778,237.439C281.66,237.394,285.116,250.298,293.101,252.737ZM280.119,258.235C274.563,257.091,271.574,257.113,266.125,258.187C271.01,255.526,276.011,256.049,280.119,258.235ZM280.177,258.187C274.092,254.156,271.294,253.624,264.765,253.309C271.219,251.597,275.967,253.938,280.177,258.187ZM279.644,257.632C274.541,252.422,271.929,251.313,265.596,249.651C272.262,249.331,276.415,252.617,279.644,257.632Z"
              clip-rule="evenodd"
              fill="rgb(62,118,187)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U145"
              style={{ mixBlendMode: "multiply" }}
              d="M334.473,202.337C341.756,207.103,336.782,231.465,332.518,238.742C328.779,245.132,330.595,249.717,324.524,261.667C322.645,265.365,314.575,270.349,303.366,269.44C284.388,267.902,280.031,266.78,290.93,287.058C294.758,294.184,295.815,300.361,299.04,307.948C287.084,306.679,275.056,300.489,273.902,299.855C266.907,296.077,262.074,291.514,258.721,285.696C256.767,282.3,255.51,277.555,254.435,273.892C254.315,250.635,256.958,240.281,290.89,233.399C291.894,229.457,292.031,226.424,291.645,224.269L304.525,214.806C321.273,200.461,322.299,197.131,334.473,202.337Z"
              opacity="0.5"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U145-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U146"
              d="M248.333,301.805C248.208,303.322,248.391,304.723,248.049,305.849C247.285,308.341,244.94,310.155,242.333,309.024L225.185,301.619C228.582,296.222,235.586,302.315,241.431,298.905C243.727,297.562,248.524,299.561,248.333,301.805Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U146-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U147"
              style={{ mixBlendMode: "multiply" }}
              d="M248.333,301.805C248.271,302.586,248.284,303.331,248.271,304.023C246.334,304.275,241.44,303.384,238.908,299.783C239.79,299.63,240.64,299.331,241.422,298.897C243.758,297.615,248.524,299.562,248.333,301.805Z"
              opacity="0.5"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U147-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U148"
              d="M306.807,258.261C297.658,257.445,274.492,257.228,267.554,263.671C259.147,271.484,254.199,291.58,248.661,301.912C245.645,303.845,240.311,300.808,240.582,298.48C245.752,276.308,249.092,252.98,256.389,245.796C266.493,235.846,280.892,234.458,306.807,233.518C310.093,233.518,313.245,234.821,315.569,237.141C317.893,239.461,319.198,242.608,319.198,245.889C319.198,249.17,317.893,252.317,315.569,254.637C313.245,256.957,310.093,258.261,306.807,258.261Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U148-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U149"
              style={{ mixBlendMode: "multiply" }}
              d="M306.807,258.261C297.658,257.445,275.274,255.396,268.354,261.839C259.947,269.648,254.199,291.58,248.661,301.912C254.111,272.836,256.753,254.385,260.209,248.745C264.828,241.233,272.729,236.528,308.393,235.273C315.237,235.273,319.185,239.056,319.185,245.889C319.185,249.168,317.881,252.313,315.561,254.632C313.24,256.952,310.091,258.257,306.807,258.261Z"
              opacity="0.5"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U149-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U150"
              d="M289.264,299.686C290.277,300.826,291.418,301.659,292,302.684C293.283,304.949,292.995,307.885,290.366,309.002L273.151,316.315C271.574,310.142,280.821,309.268,282.376,302.692C283.006,300.098,287.758,298.001,289.264,299.686Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U150-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U151"
              style={{ mixBlendMode: "multiply" }}
              d="M289.264,299.686C289.784,300.271,290.339,300.777,290.832,301.265C289.677,302.839,285.658,305.77,281.301,305.118C281.799,304.377,282.168,303.557,282.393,302.693C283.068,300.112,287.759,298.001,289.264,299.686Z"
              opacity="0.5"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U151-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U152"
              d="M310.431,240.374C293.998,239.9,273.533,239.044,265.343,247.979C258.263,255.69,260.395,265.716,264.606,275.369C269.229,286.012,276.597,297.319,281.483,302.418C283.797,303.19,289.317,301.634,290.308,299.314C286.51,293.878,272.733,268.306,280.168,262.878C283.224,260.661,289.259,261.903,295.713,262.989C302.095,264.066,306.443,264.643,311.542,262.497C316.21,260.528,320.482,256.542,323.027,249.15L310.431,240.374Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U152-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U153"
              style={{ mixBlendMode: "multiply" }}
              d="M310.431,240.373C308.028,240.302,305.546,240.227,303.019,240.174C304.031,245.282,312.678,255.166,319.087,256.7C320.812,254.423,322.146,251.876,323.036,249.162L310.431,240.373Z"
              opacity="0.5"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U153-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U154"
              d="M307.478,179.77C308.118,184.505,309.042,188.86,313.896,192.629L305.702,198.234C304.814,193.298,304.045,189.955,301.749,186.705L306.217,180.124L307.478,179.77Z"
              clip-rule="evenodd"
              fill="rgb(248,165,152)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U155"
              d="M307.479,179.77C307.697,181.77,308.125,183.742,308.753,185.654C309.197,187.565,306.173,191.228,303.508,189.831C303.025,188.727,302.429,187.675,301.731,186.691L306.199,180.111L307.479,179.77Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U155-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U156"
              d="M293.381,177.11C296.241,186.559,297.494,190.962,300.176,190.146C301.264,189.814,303.125,188.005,305.062,185.943C307.935,182.874,305.683,178.223,304.333,172.64L298.604,170.121L293.381,177.11Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U156-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U157"
              d="M293.381,177.11L293.9,178.822C296.801,179.673,300.185,176.161,300.984,175.394C302.166,178.206,303.854,181.531,306.376,183.132C306.78,180.303,305.31,176.72,304.324,172.65L298.595,170.131L293.381,177.11Z"
              clip-rule="evenodd"
              fill="rgb(248,165,152)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U158"
              d="M300.767,168.477C312.945,152.766,326.598,161.196,335.058,161.178C346.988,161.152,349.91,154.177,357.043,151.84C368.115,148.208,378.361,151.964,383.025,163.728C388.354,177.195,375.297,205.197,353.881,197.118C346.846,194.457,343.83,187.655,336.924,187.673C332.345,187.673,318.008,195.819,308.322,185.012C305.885,182.163,304.063,178.842,302.97,175.257C301.371,176.84,299.035,178.02,297.054,178.219C292.124,178.716,289.557,174.636,290.432,171.288C291.804,166.06,298.022,166.619,300.767,168.477Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U158-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U159"
              d="M383.856,175.048C381.715,188.418,370.235,203.286,353.882,197.118C346.846,194.457,343.831,187.655,336.924,187.673C332.345,187.673,318.009,195.818,308.322,185.012C305.885,182.162,304.064,178.841,302.97,175.257C301.372,176.84,299.035,178.019,297.055,178.219C293.306,178.596,290.926,176.33,290.393,173.749C294.212,177.146,299.688,176.41,303.797,172.33C312.364,182.156,317.156,183.717,323.956,183.048C334.229,182.032,337.258,180.658,341.002,180.636C347.219,180.596,351.27,187.11,358.074,188.954C365.425,190.967,378.176,188.156,383.856,175.048Z"
              clip-rule="evenodd"
              fill="rgb(36,9,61)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U160"
              d="M297.232,185.281C297.09,186.855,297.174,188.66,296.788,190.004C296.344,191.627,295.18,194.123,293.781,197.099L298.667,196.057C298.812,195.653,298.983,195.259,299.177,194.877C299.759,193.764,303.015,192.593,303.086,189.893L303.201,185.689L297.232,185.281Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U160-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U161"
              d="M297.232,185.281C297.112,186.612,297.152,188.155,296.935,189.41C298.8,192.372,300.408,191.454,302.873,191.019C303.017,190.659,303.095,190.276,303.104,189.888L303.219,185.685L297.232,185.281Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U161-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U162"
              d="M299.826,195.841C298.609,194.409,296.18,193.819,294.94,193.952C292.977,197.31,291.226,200.788,289.695,204.364C287.221,210.204,284.388,219.196,286.799,224.761C287.554,226.504,290.566,229.599,293.435,229.714C296.544,229.834,300.146,228.335,301.496,222.965C302.922,217.303,296.442,211.924,298.072,206.04C299.022,202.713,299.61,199.294,299.826,195.841Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U162-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U163"
              style={{ mixBlendMode: "multiply" }}
              d="M292.018,227.94C295.722,226.96,298.396,209.028,299.444,200.447C294.332,208.478,288.541,218.003,291.725,227.186L292.018,227.94Z"
              opacity="0.5"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U163-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U164"
              d="M308.163,191.243C301.021,194.879,284.983,225.71,293.639,228.965C298.556,230.814,303.002,224.65,306.519,219.923C315.611,207.774,318.653,185.904,308.163,191.243Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U164-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U165"
              d="M309.77,190.62C307.163,191.281,305.329,193.529,304.658,194.305C302.966,196.279,301.567,198.487,300.505,200.859C298.969,204.207,298.698,207.24,298.08,213.195C297.872,215.177,297.992,218.685,297.694,220.414C296.708,226.121,289.042,226.923,286.737,224.595C287.479,226.467,289.109,227.886,291.081,228.999C294.288,230.812,298.374,228.852,300.568,226.937C302.762,225.021,304.756,222.298,306.532,219.922C312.75,211.63,316.117,198.792,314.296,193.187C313.408,190.478,311.627,190.15,309.77,190.62Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U165-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U166"
              d="M302.055,236.847C305.608,242.98,313.327,251.552,322.565,253.667C329.556,234.599,332.998,207.244,321.743,193.361C316.791,187.255,308.553,189.37,304.307,195.17C297.742,204.109,300.243,226.156,302.055,236.847Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U166-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U167"
              style={{ mixBlendMode: "multiply" }}
              d="M302.055,236.849C303.055,238.525,304.165,240.134,305.378,241.664C317.547,242.463,326.936,237.993,328.113,231.745C328.766,228.286,329.13,222.264,329.001,216.863C327.709,205.467,321.811,194.847,317.831,193.85C315.126,193.176,307.572,198.909,305.795,201.113C305.045,211.538,321.784,224.278,300.728,227.209C301.132,230.867,301.607,234.206,302.055,236.849Z"
              opacity="0.5"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U167-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U168"
              d="M260.662,239.951L279.786,238.874C281.616,238.785,282.043,239.925,282.145,240.865L259.383,242.146L249.226,221.749C250.682,221.004,251.38,221.239,252.121,222.809L260.662,239.951Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U168-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U169"
              d="M281.287,231.247C280.026,231.629,278.848,232.244,277.814,233.061C274.931,235.163,272.578,237.131,268.829,238.967C271.081,240.812,274.283,239.69,277.121,238.209C279.035,237.211,278.769,236.941,280.936,237.322C283.104,237.703,283.628,237.876,286.266,236.2C287.509,236.324,288.731,236.479,289.93,236.644L289.393,231.136C288.544,231.096,287.705,231.043,286.883,230.977C285.014,230.799,283.13,230.89,281.287,231.247Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U169-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U170"
              d="M281.505,235.789C279.542,235.203,279.018,235.376,278.129,236.019C275.251,238.117,272.356,239.167,268.829,238.968C271.081,240.813,274.283,239.691,277.121,238.21C279.035,237.212,278.769,236.941,280.936,237.323C283.104,237.704,283.628,237.877,286.266,236.201L289.903,236.644L289.903,236.432L289.388,231.141C288.54,231.102,287.7,231.048,286.879,230.982L286.221,230.938C285.611,231.648,285.11,232.444,284.734,233.301C284.254,234.485,283.81,236.485,281.505,235.789Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U170-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U171"
              d="M322.45,200.353C329.472,216.179,333.5,229.992,323.294,235.553C316.374,239.322,295.482,238.124,287.15,236.732C286.218,234.777,286.386,231.349,287.492,230.755C296.544,228.937,305.418,228.919,312.577,226.493C319.146,224.276,313.332,214.76,309.139,208.517C305.871,203.639,302.477,197.165,309.983,193.396C316.565,190.088,320.149,195.214,322.45,200.353Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U171-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U172"
              d="M374.187,178.98L352.029,178.98C350.579,178.98,349.404,180.154,349.404,181.601L349.404,204.411C349.404,205.858,350.579,207.032,352.029,207.032L374.187,207.032C375.637,207.032,376.812,205.858,376.812,204.411L376.812,181.601C376.812,180.154,375.637,178.98,374.187,178.98Z"
              fill="url(#eeV3ClaxE6U172-fill)"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U173"
              d="M355.693,184.102C360.033,184.102,364.195,185.823,367.263,188.886C370.331,191.95,372.055,196.105,372.055,200.437L369.337,200.437C369.337,196.825,367.9,193.36,365.341,190.805C362.782,188.251,359.312,186.815,355.693,186.815L355.693,184.102Z"
              clip-rule="evenodd"
              fill="rgb(255,255,255)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U174"
              d="M355.693,188.084C358.975,188.084,362.122,189.386,364.442,191.702C366.763,194.019,368.066,197.161,368.066,200.438L365.53,200.438C365.53,197.832,364.494,195.332,362.648,193.49C360.802,191.647,358.299,190.612,355.688,190.612L355.693,188.084Z"
              clip-rule="evenodd"
              fill="rgb(255,255,255)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U175"
              d="M355.693,192.102C357.908,192.102,360.032,192.98,361.598,194.543C363.163,196.107,364.043,198.227,364.043,200.438L361.694,200.438C361.694,198.849,361.061,197.325,359.936,196.202C358.811,195.078,357.285,194.447,355.693,194.447L355.693,192.102Z"
              clip-rule="evenodd"
              fill="rgb(255,255,255)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U176"
              d="M357.092,196.066C357.671,196.066,358.237,196.238,358.718,196.559C359.199,196.88,359.574,197.336,359.796,197.87C360.017,198.404,360.075,198.992,359.962,199.559C359.85,200.126,359.571,200.646,359.161,201.055C358.752,201.464,358.231,201.742,357.663,201.855C357.095,201.967,356.507,201.909,355.972,201.688C355.437,201.467,354.98,201.093,354.658,200.612C354.337,200.132,354.165,199.567,354.165,198.989C354.165,198.214,354.473,197.47,355.022,196.922C355.571,196.374,356.316,196.066,357.092,196.066Z"
              clip-rule="evenodd"
              fill="rgb(255,255,255)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U177"
              d="M259.605,224.259L261.67,225.102L259.982,229.221L257.917,228.379L259.605,224.259ZM301.797,121.207L303.858,122.05L302.171,126.173L300.11,125.331L301.797,121.207ZM297.578,131.503L299.639,132.341L297.951,136.465L295.89,135.623L297.578,131.503ZM293.359,141.804L295.424,142.651L293.736,146.771L291.671,145.928L293.359,141.804ZM289.14,152.123L291.205,152.965L289.517,157.089L287.452,156.247L289.14,152.123ZM284.92,162.428L286.986,163.27L285.298,167.394L283.233,166.552L284.92,162.428ZM280.701,172.742L282.762,173.585L281.079,177.708L279.013,176.866L280.701,172.742ZM276.482,183.047L278.547,183.89L276.859,188.014L274.794,187.171L276.482,183.047ZM272.263,193.353L274.328,194.195L272.64,198.319L270.575,197.476L272.263,193.353ZM268.043,203.658L270.108,204.5L268.421,208.624L266.36,207.782L268.043,203.658ZM263.824,213.954L265.889,214.797L264.201,218.921L262.136,218.078L263.824,213.954Z"
              clip-rule="evenodd"
              fill="rgb(11,162,211)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U178"
              d="M28.4731,130.466L63.0178,130.466C63.2837,130.456,63.5482,130.509,63.7894,130.621C64.0306,130.733,64.2416,130.901,64.4048,131.111C64.5681,131.321,64.6789,131.566,64.7281,131.827C64.7773,132.089,64.7635,132.358,64.6877,132.612L58.2256,161.364C58.0749,161.958,57.7371,162.487,57.2621,162.874C56.7871,163.261,56.2,163.486,55.5874,163.515L21.0471,163.515C20.7808,163.525,20.5157,163.472,20.274,163.36C20.0324,163.247,19.8211,163.079,19.6577,162.869C19.4944,162.658,19.3837,162.412,19.3349,162.15C19.2861,161.889,19.3006,161.619,19.3772,161.364L25.8394,132.612C25.9894,132.02,26.3265,131.491,26.8008,131.104C27.2751,130.718,27.8615,130.494,28.4731,130.466Z"
              clip-rule="evenodd"
              fill="rgb(48,97,173)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U179"
              d="M55.9121,122.883L22.8063,122.883C20.7753,122.883,19.1289,124.527,19.1289,126.554L19.1289,159.009C19.1289,161.037,20.7753,162.68,22.8063,162.68L55.9121,162.68C57.9431,162.68,59.5895,161.037,59.5895,159.009L59.5895,126.554C59.5895,124.527,57.9431,122.883,55.9121,122.883Z"
              fill="rgb(242,243,250)"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U180"
              d="M56.3294,126.387L22.3843,126.387C21.8716,126.387,21.4561,126.802,21.4561,127.313L21.4561,129.375C21.4561,129.887,21.8716,130.302,22.3843,130.302L56.3294,130.302C56.8421,130.302,57.2577,129.887,57.2577,129.375L57.2577,127.313C57.2577,126.802,56.8421,126.387,56.3294,126.387Z"
              fill="rgb(220,232,246)"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U181"
              d="M56.6359,134.781L22.0778,134.781C21.7344,134.781,21.4561,135.059,21.4561,135.402L21.4561,136.794C21.4561,137.137,21.7344,137.415,22.0778,137.415L56.6359,137.415C56.9793,137.415,57.2577,137.137,57.2577,136.794L57.2577,135.402C57.2577,135.059,56.9793,134.781,56.6359,134.781Z"
              fill="rgb(220,232,246)"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U182"
              d="M56.6359,141.555L22.0778,141.555C21.7344,141.555,21.4561,141.833,21.4561,142.175L21.4561,143.568C21.4561,143.911,21.7344,144.189,22.0778,144.189L56.6359,144.189C56.9793,144.189,57.2577,143.911,57.2577,143.568L57.2577,142.175C57.2577,141.833,56.9793,141.555,56.6359,141.555Z"
              fill="rgb(220,232,246)"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U183"
              d="M56.6359,148.332L22.0778,148.332C21.7344,148.332,21.4561,148.61,21.4561,148.953L21.4561,150.345C21.4561,150.688,21.7344,150.966,22.0778,150.966L56.6359,150.966C56.9793,150.966,57.2577,150.688,57.2577,150.345L57.2577,148.953C57.2577,148.61,56.9793,148.332,56.6359,148.332Z"
              fill="rgb(220,232,246)"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eeV3ClaxE6U184"
              d="M41.0823,133.88L52.1234,133.88C52.6548,133.895,53.1638,134.097,53.561,134.45C53.9582,134.802,54.2182,135.284,54.2952,135.809L57.5019,161.585C57.5395,161.826,57.5238,162.073,57.4559,162.307C57.3879,162.542,57.2693,162.759,57.1085,162.943C56.9476,163.126,56.7484,163.273,56.5248,163.372C56.3012,163.47,56.0586,163.519,55.8142,163.514L20.8253,163.514C20.2939,163.499,19.7849,163.297,19.3877,162.944C18.9905,162.592,18.7306,162.11,18.6535,161.585L17.9429,155.869L15.4469,135.809L15.0027,132.261C14.945,131.884,14.9706,131.499,15.0776,131.133C15.1846,130.767,15.3705,130.429,15.6223,130.142C15.874,129.855,16.1855,129.627,16.535,129.473C16.8845,129.319,17.2634,129.243,17.6453,129.251L32.2218,129.251C33.8828,129.251,34.7045,129.854,35.7748,131.237C37.6313,133.605,38.0088,133.88,41.0823,133.88Z"
              clip-rule="evenodd"
              fill="url(#eeV3ClaxE6U184-fill)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
          </g>
          <clipPath id="eeV3ClaxE6U185">
            <rect
              id="eeV3ClaxE6U186"
              width="432"
              height="337"
              rx="0"
              ry="0"
              fill="rgb(255,255,255)"
              stroke="none"
              strokeWidth="1"
            ></rect>
          </clipPath>
        </g>
      </svg>
    </div>
  );
};
